{
  "LogbookApp_version_major": "1.1",

  "RecordingClockWarning_title": "Recording time warning",
  "RecordingClockWarning_acknowledge": "Acknowledge",
  "RecordingClockWarning_system": "The computer clock is unreliable. Recording continues using GPS time.",
  "RecordingClockWarning_gps": "The GPS clock is unreliable. Recording continues using the computer clock.",
  "RecordingClockWarning_paused": "No reliable time source is available. Automatic recording and new current-time entries are paused until GPS or the computer clock recovers. Historical entries can still be edited.",

  "Layout": "",
  "Layout_documentation": "DOCUMENTATION",
  "Layout_support": "Support",

  "OpenServerDialog_title": "Open LOGBOOK Cloud",
  "OpenServerDialog_opening": "Opening LOGBOOK Cloud...",
  "OpenServerDialog_failed": "LOGBOOK Cloud could not be opened. Check your connection and allow pop-up windows, then try again.",
  "OpenServerDialog_close": "Close",
  "OpenServerDialog_retry": "Try again",

  "AboutView": "",
  "AboutView_title": "About LOGBOOK",
  "AboutView_version": "Version",
  "AboutView_website": "Website",
  "AboutView_support": "Support",
  "AboutView_copyright": "Copyright © 2026 by Trimutic UG",
  "AboutView_uploadAppData": "Upload App data to Support",
  "AboutView_uploadAppDataUploading": "Uploading…",
  "AboutView_uploadAppDataSuccess": "App data uploaded",
  "AboutView_uploadAppDataError": "Failed to upload app data",

  "AccountView": "",
  "AccountView_cancel": "Cancel",
  "AccountView_cancel_plan": "Cancel plan",
  "AccountView_currency": "Currency",
  "AccountView_currency_EUR": "Euro (€)",
  "AccountView_currency_USD": "US Dollar ($)",
  "AccountView_duration": "Duration",
  "AccountView_duration_5": "5 days",
  "AccountView_duration_30": "monthly\u00A0billing, monthly\u00A0cancelable",
  "AccountView_duration_120": "4 months",
  "AccountView_duration_365": "annual\u00A0billing, annually\u00A0cancelable",
  "AccountView_duration_30_iap": "monthly\u00A0billing, auto-renews unless\u00A0canceled",
  "AccountView_feature_active_ships": "Active Ships: {amount}",
  "AccountView_feature_active_users": "Active Users: {amount}",
  "AccountView_feature_active_tenders": "Active Tenders: {amount}",
  "AccountView_feature_support_1": "Standard Support",
  "AccountView_feature_support_10": "Pro-Support",
  "AccountView_feature_support_100": "Master Support",
  "AccountView_feature_unlimited": "Unlimited",
  "AccountView_pay": "Confirm recurring payment of {price}",
  "AccountView_pay_cancel": "Cancel",
  "AccountView_pay_processing": "Processing payment...",
  "AccountView_payment_information": "Payment information",
  "AccountView_payment_title": "{plan} subscription for {price}",
  "AccountView_plans": "Our subscription plans",
  "AccountView_plans_iPad": "Your LOGBOOK subscription",
  "AccountView_plan_captain": "LOGBOOK Captain",
  "AccountView_plan_master_captain": "LOGBOOK Master Captain",
  "AccountView_plan_skipper": "LOGBOOK Skipper",
  "AccountView_plan_trial": "LOGBOOK Trial",
  "AccountView_price_duration_5": "5 days",
  "AccountView_price_duration_30": "month",
  "AccountView_price_duration_365": "year",
  "AccountView_price_free": "Free",
  "AccountView_price_EUR": "{price} € per {duration}",
  "AccountView_price_USD": "${price} per {duration}",
  "AccountView_price_native": "{price} per {duration}",
  "AccountView_price_or_monthly": " or ",
  "AccountView_select_plan": "Select plan",
  "AccountView_subscribe": "Subscribe",
  "AccountView_subscribe_api": "Subscribe",
  "AccountView_time_left": "{days} days left",
  "AccountView_renews_in": "Renews in {days} days",
  "AccountView_cancelled_ends": "Cancelled — access ends in {days} days",
  "AccountView_apple_cancel_info_title": "Manage your subscription",
  "AccountView_apple_cancel_info_message": "This subscription was purchased through the App Store, so it must be managed there. On your iPhone or iPad, open Settings, tap your name, then Subscriptions, select LOGBOOK and cancel it there. Your access stays active until the end of the current billing period.",
  "AccountView_taxes": "Taxes included",
  "AccountView_terms_of_use": "Terms of Use",
  "AccountView_privacy_policy": "Privacy Policy",
  "AccountView_restore_purchases": "Restore Purchases",
  "AccountView_restore_purchases_running": "Restoring…",
  "AccountView_restore_nothing_title": "No purchases found",
  "AccountView_restore_nothing_message": "There is no active subscription on this Apple ID to restore.",
  "AccountView_restore_claim_title": "Move subscription",
  "AccountView_restore_claim_message": "This Apple ID's subscription is currently linked to “{account}”. Move it to “{current}”? “{account}” will lose access.",
  "AccountView_restore_claim_confirm": "Move it here",
  "AccountView_restore_claim_cancel": "Keep it there",
  "AccountView_linked_to_other_account": "This Apple ID's subscription is linked to the Logbook account “{account}”.",
  "AccountView_linked_to_other_account_hint": "Use Restore Purchases to move it to this account, or pay by card on the web.",
  "AccountView_title": "Account Settings",
  "AccountView_total": "Total due",

  "AccountSettingsView_alert_no_internet_title": "No internet connection available",
  "AccountSettingsView_alert_no_internet_text": "An internet connection is required to change account settings.",

  "AccountSettingsView_error_passwordInvalid": "Entered password does not match the current one.",
  "AccountSettingsView_error_passwordConfirmationMismatch": "Password confirmation does not match password.",
  "AccountSettingsView_error_Not Found": "Not found",
  "AccountSettingsView_error_accountUserSelfAction": "You can't change, deactivate, or remove your own account access.",
  "AccountSettingsView_error_accountUserLastAdmin": "The account must keep at least one active admin.",
  "AccountSettingsView_error_account_user_action_failed": "Something went wrong. Please try again.",
  "AccountSettingsView_error_account_update_failed": "Something went wrong. Please try again.",
  "AccountSettingsView_change_password": "Change password",
  "AccountSettingsView_confirm_new_password": "New password confirmation",
  "AccountSettingsView_current_password": "Current password",
  "AccountSettingsView_new_password": "New password",

  "AccountSettingsView_import_ship": "Import from LogbookSuite",
  "AccountSettingsView_import_trips": "Import Passages for \"{name}\" from LogbookSuite",
  "AccountSettingsView_new_ship": "Start with a new Ship",
  "AccountSettingsView_select_ship": "Select from your Ships",
  "AccountSettingsView_select_shared_ship": "Select from shared Ships",
  "AccountSettingsView_deselect_ship": "Close Ship",
  "AccountSettingsView_add_new_ship": "Add new Ship",
  "AccountSettingsView_users_list": "List of all users in your account",

  "AccountSettingsView_tab_ships": "Your Ships",
  "AccountSettingsView_tab_subscription": "Your Subscription",
  "AccountSettingsView_tab_users": "Your Users",

  "AccountSettingsView_ship_open_here_notice": "Close the LOGBOOK you already have open on this device to select another ship.",
  "AccountSettingsView_companion_reconnect_notice": "The connection to your Primary LOGBOOK was lost — its address on this network may have changed. Connect again to continue.",
  "AccountSettingsView_ship_close_companion": "Disconnect LOGBOOK Companion",
  "AccountSettingsView_ship_close_confirm": "Close LOGBOOK",
  "AccountSettingsView_ship_logbook": "View LOGBOOK for \"{name}\"",

  "AccountSettingsView_account_data": "Your account data",
  "AccountSettingsView_account_edit_cancel": "Cancel",
  "AccountSettingsView_account_edit_save": "Save",
  "AccountSettingsView_account_login": "Login name (email)",
  "AccountSettingsView_account_name": "Account name",
  "AccountSettingsView_account_settings": "Account Settings",
  "AccountSettingsView_account_user_level": "Permissions",
  "AccountSettingsView_account_user_level_admin": "Admin",
  "AccountSettingsView_account_user_level_user": "User",
  "AccountSettingsView_account_user_level_disabled": "Deactivated",
  "AccountSettingsView_deactivate_user": "Deactivate",
  "AccountSettingsView_reactivate_user": "Reactivate",
  "AccountSettingsView_remove_user": "Remove",
  "AccountSettingsView_user_deactivate_confirm_title": "Deactivate user",
  "AccountSettingsView_user_deactivate_confirm_message": "This user still has access to a ship on this account. Do you really want to deactivate their account?",
  "AccountSettingsView_user_deactivate_confirm_accept": "Deactivate",
  "AccountSettingsView_user_deactivate_confirm_cancel": "Cancel",
  "AccountSettingsView_user_remove_confirm_title": "Remove user",
  "AccountSettingsView_user_remove_confirm_message": "This user still has access to a ship on this account. Do you really want to remove them from the account? This cannot be undone.",
  "AccountSettingsView_user_remove_confirm_accept": "Remove",
  "AccountSettingsView_user_remove_confirm_cancel": "Cancel",
  "AccountSettingsView_change_plan": "Change your plan",
  "AccountSettingsView_customer_name": "Name",
  "AccountSettingsView_edit_account": "Edit account",
  "AccountSettingsView_remove_account": "Remove account",
  "AccountSettingsView_plan": "Your current plan",
  "AccountSettingsView_plans": "LOGBOOK Plans",
  "AccountSettingsView_subscription": "Your Subscription",
  "AccountSettingsView_user_account": "Account",
  "AccountSettingsView_user_name": "Name",
  "AccountSettingsView_user_email": "Email",
  "AccountSettingsView_user_shortname": "Short name",
  "AccountSettingsView_user_status": "Status",
  "AccountSettingsView_user_status_active": "Active",
  "AccountSettingsView_user_status_invited": "Invited",
  "AccountSettingsView_user_permissions": "Permissions",
  "AccountSettingsView_current_ship": "Your current ship is {name}",
  "AccountSettingsView_no_current_ship": "No ship is selected",
  "AccountSettingsView_valid_until": "Valid until",
  "AccountSettingsView_trial_days_remaining": "Trial days remaining",
  "AccountSettingsView_trial_days_value": "{days} days",

  "AccountSettingsView_user_crew_role": "Crew role",
  "AccountSettingsView_ship_user_crew_role_crew": "Crew",
  "AccountSettingsView_ship_user_crew_role_none": "None",
  "AccountSettingsView_ship_user_crew_role_owner": "Account holder",
  "AccountSettingsView_ship_user_crew_role_skipper": "Skipper",

  "AccountSettingsView_ship_user_level": "Permissions",
  "AccountSettingsView_ship_user_level_primary": "Primary",
  "AccountSettingsView_ship_user_level_editAll": "View and edit all",
  "AccountSettingsView_ship_user_level_editCurrent": "View and edit current voyage",
  "AccountSettingsView_ship_user_level_viewAll": "View all",
  "AccountSettingsView_ship_user_level_viewCurrent": "View current voyage",
  "AccountSettingsView_ship_user_level_none": "None",

  "AppDisconnectedView": "",
  "AppDisconnectedView_connection_overlay_reload": "Reload",
  "AppDisconnectedView_connection_overlay_reloading": "Reloading …",
  "AppDisconnectedView_connection_overlay_title": "Connection interrupted",
  "AppDisconnectedView_disconnect_companion": "Disconnect LOGBOOK Companion",

  "AppHeaderView": "",

  "AppOverlayContentView": "",
  "AppOverlayContentView_cancel": "Cancel",
  "AppOverlayContentView_connect_logbook": "Connect with Primary LOGBOOK",
  "AppOverlayContentView_connect_logbook_title": "Connect with Primary LOGBOOK for \"{name}\"",
  "AppOverlayContentView_connect_logbook_failed": "Failed to connect with Primary LOGBOOK",
  "AppOverlayContentView_connect_logbook_connecting": "Connecting with the Primary LOGBOOK for \"{name}\"…",
  "AppOverlayContentView_connect_logbook_connecting_short": "Connecting…",
  "AppOverlayContentView_connect_logbook_timeout": "Could not reach \"{name}\" automatically — enter its address",
  "AppOverlayContentView_connect_logbook_not_discovered": "“{name}” isn’t visible on this network. Check that both devices use the same Wi-Fi, or enter its address below.",
  "AppOverlayContentView_connect_logbook_ambiguous": "More than one device is offering “{name}”. Enter the address of the one you want to connect to.",
  "AppOverlayContentView_connect_logbook_unresolved": "“{name}” was found, but its address could not be determined. Enter it below.",
  "AppOverlayContentView_connect_logbook_unreachable": "No answer from “{name}” at {address}. Check the address, and that both devices are on the same network.",
  "AppOverlayContentView_connect_logbook_refused": "“{name}” refused the connection. Make sure this device’s user has access to that logbook.",
  "AppOverlayContentView_connect_logbook_not_claimed": "“{name}” isn’t open on its Primary LOGBOOK right now. Open it there, then try again.",
  "AppOverlayContentView_connect_logbook_not_accessible": "You don’t have access to “{name}”.",
  "AppOverlayContentView_connect_logbook_address_invalid": "Enter the address as host:port, for example 192.168.1.20:18092.",
  "AppOverlayContentView_connect_logbook_own_device": "“{name}” is this device’s own logbook — open it instead of connecting to it.",
  "AppOverlayContentView_connect_logbook_outdated_title": "This app is out of date",
  "AppOverlayContentView_connect_logbook_outdated": "The Primary LOGBOOK for \"{name}\" runs a newer version than this device. Update LOGBOOK here to connect.",
  "AppOverlayContentView_connect_logbook_outdated_version": "This device runs version {version}.",
  "AppOverlayContentView_connect_logbook_outdated_appstore": "Please update LOGBOOK in the App Store.",
  "AppOverlayContentView_connect_logbook_outdated_playstore": "Please update LOGBOOK in the Play Store.",
  "AppOverlayContentView_connect_logbook_outdated_download": "Download the latest version",
  "AppOverlayContentView_connection": "Enter the IP and port of the Primary LOGBOOK to establish a connection. Use the format \"IP:Port\", e.g. \"192.168.0.100:8000\".",
  "AppOverlayContentView_connection_host": "Host",
  "AppOverlayContentView_connection_port": "Port",
  "AppOverlayContentView_disconnect_logbook": "Disconnect Primary LOGBOOK",
  "AppOverlayContentView_disconnect_ship": "Disconnect Ship",
  "AppOverlayContentView_disconnect_ship_title": "Disconnect the Ship from LOGBOOK Cloud",
  "AppOverlayContentView_import_reset": "Reset all imported data",
  "AppOverlayContentView_import_reset_confirm_title": "Reset all imported data?",
  "AppOverlayContentView_import_reset_confirm_text": "This will permanently delete all imported passages. This action cannot be undone.",
  "AppOverlayContentView_import_reset_confirm_no": "Cancel",
  "AppOverlayContentView_import_reset_confirm_yes": "Yes, reset",
  "AppOverlayContentView_import_resetting": "Resetting…",
  "AppOverlayContentView_import_ship_cancel": "Cancel",
  "AppOverlayContentView_import_ship_choose": "Choose file",
  "AppOverlayContentView_import_ship_title": "Import from Logbook Suite",
  "AppOverlayContentView_import_trips": "Import from Logbook Suite",
  "AppOverlayContentView_import_status_in_progress": "Import in progress since {time}",
  "AppOverlayContentView_import_status_complete": "Import completed on {date}",
  "AppOverlayContentView_import_status_failed": "Previous import attempt failed. Please try again or contact support for assistance.",
  "AppOverlayContentView_options_cruises": "Total Voyages in LOGBOOK:",
  "AppOverlayContentView_options_days": "Total Days in LOGBOOK:",
  "AppOverlayContentView_options_first_day": "First day in LOGBOOK:",
  "AppOverlayContentView_options_last_day": "Last day in LOGBOOK:",
  "AppOverlayContentView_options_trips": "Total Passages in LOGBOOK:",
  "AppOverlayContentView_options_ship": "Options for \"{name}\"",
  "AppOverlayContentView_options_ship_title": "Info on the Ship",
  "AppOverlayContentView_options_update": "Last Synchronization:",
  "AppOverlayContentView_logout_confirm": "Logout",
  "AppOverlayContentView_logout_confirm_cancel": "Cancel",
  "AppOverlayContentView_logout_confirm_title": "Confirm Logout",
  "AppOverlayContentView_remove_account_cancel": "Cancel",
  "AppOverlayContentView_remove_account_confirm": "Confirm",
  "AppOverlayContentView_remove_account_confirm_title": "Account removal",
  "AppOverlayContentView_session_expired_dismiss": "Continue without syncing",
  "AppOverlayContentView_session_expired_email": "Email",
  "AppOverlayContentView_session_expired_failed": "Login failed. Please check your email and password and try again.",
  "AppOverlayContentView_session_expired_failed_request": "The login could not be sent. Please check your internet connection and try again.",
  "AppOverlayContentView_session_expired_login": "Log in",
  "AppOverlayContentView_session_expired_login_loading": "Logging in…",
  "AppOverlayContentView_session_expired_password": "Password",
  "AppOverlayContentView_session_expired_title": "Login required",
  "AppOverlayContentView_ship_close_confirm": "Confirm Close LOGBOOK",
  "AppOverlayContentView_ship_close_confirm_cancel": "Cancel",
  "AppOverlayContentView_ship_close_confirm_closing": "Closing LOGBOOK…",
  "AppOverlayContentView_ship_close_confirm_title": "Confirm Ship close",
  "AppOverlayContentView_ship_close_failed": "Could not close LOGBOOK. Check your internet connection and try again.",
  "AppOverlayContentView_ship_close_failed_offline": "LOGBOOK could not be closed because this device is offline. Check your internet connection and try again, or close it locally only.",
  "AppOverlayContentView_ship_close_failed_server": "LOGBOOK could not be closed because the LOGBOOK Cloud is temporarily unavailable. Please try again in a moment.",
  "AppOverlayContentView_ship_force_close": "Force close locally",
  "AppOverlayContentView_ship_force_close_confirm": "Confirm force close",
  "AppOverlayContentView_ship_view_ships_cloud": "View Ships list in Cloud",
  "AppOverlayContentView_ships_cloud": "View Ships list in Cloud",
  "AppOverlayContentView_user_settings": "User Settings",
  "AppOverlayContentView_ship_not_closed_title": "Disconnect Primary LOGBOOK \"{name}\" from LOGBOOK Cloud",
  "AppOverlayContentView_ship_open_title": "The Primary LOGBOOK for \"{name}\" is already open",
  "AppOverlayContentView_read_more": "Read more",

  "ChangeLogView_change_log": "Change Log",
  "ChangeLogView_download": "Download",
  "ChangeLogView_change_welcome": "Welcome to LOGBOOK App Version {version}!",
  "ChangeLogView_change_fixed_info": "Here you will find information on all changes made. The Change Log window will be shown at each reload of the App if there are new changes.",
  "ChangeLogView_new_version_available": "New update available for Download",
  "ChangeLogView_title": "What's new in LOGBOOK",

  "Component_ToggleSwitch": "",
  "Component_ToggleSwitch_off": "OFF",
  "Component_ToggleSwitch_on": "ON",

  "CruiseCalendarView": "",
  "CruiseCalendarView_actions_print": "Print",
  "CruiseCalendarView_focus": "Focus",
  "CruiseCalendarView_start_ship": "Open the new ship in the LOGBOOK app",
  "CruiseCalendarView_open_in_cloud": "Open in Cloud",
  "CruiseCalendarView_untitled_cruise": "Untitled voyage",

  "CruiseEditView_title": "Name of the voyage",

  "CruiseView": "",
  "CruiseView_actions_print": "Print",
  "CruiseView_empty": "Create a passage to continue",
  "CruiseView_menu_labels": "Filter",
  "CruiseView_menu_toggle_labels_off": "Labels off",
  "CruiseView_menu_toggle_labels_on": "Labels on",
  "CruiseView_tab_cruise": "Voyage",
  "CruiseView_tab_stats": "Statistics",
  "CruiseView_tab_track": "Track",
  "CruiseView_tab_print": "Print",
  "CruiseView_print_cruise": "Print this voyage",
  "CruiseView_untitled_cruise": "Untitled voyage",

  "DayEditView": "",
  "DayEditView_comment": "Comment",
  "DayEditView_crew": "Crew",
  "DayEditView_end_location": "End location",
  "DayEditView_passengers": "Passengers",
  "DayEditView_skipper": "Skipper",
  "DayEditView_start_location": "Start location",
  "DayEditView_status_day": "Day",
  "DayEditView_status_overnight": "Overnight",
  "DayEditView_sunrise": "Sunrise",
  "DayEditView_sunset": "Sunset",
  "DayEditView_timezone": "Timezone",
  "DayEditView_other_skipper": "New skipper",
  "DayEditView_other_crew": "New person",
  "DayEditView_save_error_generic": "Not saved. Please try again.",
  "DayEditView_details_last_edited_by": "Last edited by {name}",
  "DayEditView_details_last_edited": "Last edited",

  "DayHeaderView": "",
  "DayHeaderView_today": "Today",
  "DayHeaderView_nextDay": "Next day",
  "DayHeaderView_yesterday": "Yesterday",

  "DayView": "",
  "DayView_logs_empty": "No logs yet",
  "DayView_logs_empty_past": "No logs",
  "DayView_tab_day": "Day",
  "DayView_tab_stats": "Statistics",
  "DayView_tab_track": "Track",
  "DayView_tab_watches": "Watch plan",
  "DayView_tab_weather": "Weather",
  "DayView_tab_weather_forecast": "Weather forecast",
  "DayView_tab_journal": "Journal",
  "DayView_tab_technical": "Technical",
  "DayView_tab_print": "Print",
  "DayView_print_days": "Print all days of this passage",
  "DayView_print_day": "Print this day",

  "DayWatchView": "",
  "DayWatchView_groups_title": "Groups for Watches",
  "DayWatchView_add_group": "Add Group",
  "DayWatchView_groups_name": "Watch Group Name",
  "DayWatchView_groups_people": "Crew Members",

  "DayWatchView_shifts_title": "Watch plan",
  "DayWatchView_shifts_hour": "Hour",
  "DayWatchView_shifts_duration": "Duration (h)",
  "DayWatchView_shifts_group": "Watch Group",
  "DayWatchView_shifts_group_undefined": "*Choose*",
  "DayWatchView_add_shift": "Add Watch Shift",
  "DayWatchView_reset_shifts": "Reset Watch Shifts",
  "DayWatchView_shifts_unit_hour": "h",

  "EditHistory": "",
  "EditHistory_title": "History of changes",
  "EditHistory_field": "Field",
  "EditHistory_previous": "Previous",
  "EditHistory_new": "New",
  "EditHistory_changed": "Changed",
  "EditHistory_entry_meta": "{date} by {name}",

  "FocusView": "",
  "FocusView_actions_add_cruise": "Voyage",
  "FocusView_actions_add_trip": "Passage",
  "FocusView_actions_complete_cruise": "Voyage",
  "FocusView_actions_complete_trip": "Passage",
  "FocusView_actions_print": "Print",
  "FocusView_start_trip": "Start Passage",
  "FocusView_cancel": "Cancel",
  "FocusView_close": "Close",
  "FocusView_confirm": "Continue",
  "FocusView_confirm_cruise_title": "Start new Voyage",
  "FocusView_confirm_trip_title": "Start new Passage",
  "FocusView_set_timezone": "Set timezone",
  "FocusView_tile_new_trip": "Starting a new Passage",
  "FocusView_timezone": "Timezone set for the passage",
  "FocusView_current_time": "Calcuated current time",
  "FocusView_subscription_expired": "Subscription ended",
  "FocusView_trial_expired": "Trial phase ended",
  "FocusView_view_plans": "View subscription plans",

  "GraphView": "",
  "GraphView_graph_pressure": "Pressure",
  "GraphView_graph_temperature": "Temperature",
  "GraphView_graph_windDirection": "Wind direction",
  "GraphView_graph_windDirection_unit": "{direction}°",
  "GraphView_graph_windSpeed": "Wind speed",
  "GraphView_no_data": "No data",

  "InstrumentsView": "",
  "InstrumentsView_compass_title": "Compass",
  "InstrumentsView_compass_title_magnetic": "Compass (mag.)",
  "InstrumentsView_compass_title_true": "Compass (true)",
  "InstrumentsView_course_title": "Course",
  "InstrumentsView_depth_title": "Depth",
  "InstrumentsView_depth_title_DBK": "Below Keel",
  "InstrumentsView_depth_title_DBS": "Below Surface",
  "InstrumentsView_depth_title_DBT": "Below Transponder",
  "InstrumentsView_depth_title_DPT": "Water",
  "InstrumentsView_engine_title_single": "Engine",
  "InstrumentsView_engine_title_multiple": "Engines",
  "InstrumentsView_nmea_lost_title": "NMEA connection lost",
  "InstrumentsView_speed_title": "Speed",
  "InstrumentsView_wind_title": "Wind",
  "InstrumentsView_wind_title_apparent": "Apparent",
  "InstrumentsView_wind_title_true": "True",
  "InstrumentsView_wind_title_trueRelative": "True (rel.)",
  "InstrumentsView_wind_side_port": "P",
  "InstrumentsView_wind_side_starboard": "SB",

  "LogEnvironmentView": "",
  "LogEnvironmentView_current_direction_speed": "Current: Direction | Speed",
  "LogEnvironmentView_pressure": "Pressure",
  "LogEnvironmentView_save_error_fields": "Not saved — not allowed: {fields}",
  "LogEnvironmentView_save_error_generic": "Not saved. Please try again.",

  "LogEnvironmentView_seastate": "Seastate",
  "LogEnvironmentView_seastate_undefined": " ",
  "LogEnvironmentView_seastate_": " ",

  "LogEnvironmentView_seastate_0": "0 Calm (glassy)",
  "LogEnvironmentView_seastate_1": "1 Calm (rippled) < 0.1m",
  "LogEnvironmentView_seastate_2": "2 Smooth (wavelets) < 0.5m",
  "LogEnvironmentView_seastate_3": "3 Slight < 1.25m",
  "LogEnvironmentView_seastate_4": "4 Moderate < 2.5m",
  "LogEnvironmentView_seastate_5": "5 Rough < 4m",
  "LogEnvironmentView_seastate_6": "6 Very rough < 6m",
  "LogEnvironmentView_seastate_7": "7 High < 9m",
  "LogEnvironmentView_seastate_8": "8 Very high < 14m",
  "LogEnvironmentView_seastate_9": "9 Phenomenal > 14m",
  "LogEnvironmentView_seastate_10": "Confused sea swell",
  "LogEnvironmentView_other": "New seastate",

  "LogEnvironmentView_current_direction_undefined": " ",
  "LogEnvironmentView_current_direction_": " ",
  "LogEnvironmentView_current_direction_0": "0°",
  "LogEnvironmentView_current_direction_1": "90°",
  "LogEnvironmentView_current_direction_2": "180°",
  "LogEnvironmentView_current_direction_3": "270°",
  "LogEnvironmentView_other_direction": "Other direction",

  "LogEnvironmentView_weather_": "   ",
  "LogEnvironmentView_weather_field": "Weather",
  "LogEnvironmentView_weather_1": "clear sky",
  "LogEnvironmentView_weather_2": "fine",
  "LogEnvironmentView_weather_3": "half cloud",
  "LogEnvironmentView_weather_4": "cloudy",
  "LogEnvironmentView_weather_5": "overcast",
  "LogEnvironmentView_weather_6": "drizzle",
  "LogEnvironmentView_weather_7": "moderate rain",
  "LogEnvironmentView_weather_8": "heavy rain",
  "LogEnvironmentView_weather_9": "shower of rain",
  "LogEnvironmentView_weather_10": "haze",
  "LogEnvironmentView_weather_11": "mist",
  "LogEnvironmentView_weather_12": "fog",
  "LogEnvironmentView_weather_13": "sleet",
  "LogEnvironmentView_weather_14": "hail",
  "LogEnvironmentView_weather_15": "thunderstorm",
  "LogEnvironmentView_weather_16": "snow",
  "LogEnvironmentView_weather_temp_rel_humidity": "Weather | Temp. | Rel. Humidity",
  "LogEnvironmentView_weather_temp": "Air Temnperature",
  "LogEnvironmentView_weather_rel_humidity": "Relative Humidity",
  "LogEnvironmentView_wind_direction_speed": "Wind: Direction | Speed",

  "LogNavigationView": "",
  "LogNavigationView_comment": "Comment",
  "LogNavigationView_course": "Course",
  "LogNavigationView_course_to_wind": "Course to wind",
  "LogNavigationView_point_of_sail_noGo": "Head to wind",
  "LogNavigationView_point_of_sail_closeHauled": "Close-hauled",
  "LogNavigationView_point_of_sail_beamReach": "Beam reach",
  "LogNavigationView_point_of_sail_broadReach": "Broad reach",
  "LogNavigationView_point_of_sail_running": "Running",
  "LogNavigationView_wind_side_port": "P",
  "LogNavigationView_wind_side_starboard": "SB",
  "LogNavigationView_depth": "Depth",
  "LogNavigationView_distance": "Distance",
  "LogNavigationView_engine": "Engine",
  "LogNavigationView_engines": "Engines",
  "LogNavigationView_engine_name": "Engine {name}",
  "LogNavigationView_heading": "Heading",
  "LogNavigationView_location": "Location during stop",
  "LogNavigationView_log": "Log",
  "LogNavigationView_position": "Position: Lat | Lon",
  "LogNavigationView_sails": "Sails",
  "LogNavigationView_sog": "SOG",
  "LogNavigationView_status": "Status",
  "LogNavigationView_status_anchor": "At anchor",
  "LogNavigationView_status_buoy": "At buoy",
  "LogNavigationView_status_drifting": "Drifting",
  "LogNavigationView_status_inmotion": "In motion",
  "LogNavigationView_status_none": "None",
  "LogNavigationView_status_offboard": "Offboard",
  "LogNavigationView_status_onboard": "Onboard",
  "LogNavigationView_status_port": "In port",
  "LogNavigationView_status_lock": "Lock",
  "LogNavigationView_status_bunkering": "Fuel station",
  "LogNavigationView_status_bridge": "Bridge",
  "LogNavigationView_status_waiting": "Waiting",

  "LogNavigationView_stw": "STW",
  "LogNavigationView_time": "Time",
  "LogNavigationView_time_utc": "UTC",

  "LogNavigationView_created": "Log entry created at",
  "LogNavigationView_updated": "Log entry updated at",
  "LogNavigationView_engine_rpms": "Engine RPM",
  "LogNavigationView_save_error_fields": "Not saved — not allowed: {fields}",
  "LogNavigationView_save_error_generic": "Not saved. Please try again.",

  "LogWatchView": "",
  "LogWatchView_watch": "Watch",
  "LogWatchView_watch_comment": "Watch Comment",
  "LogWatchView_save_error_generic": "Not saved. Please try again.",

  "LogView": "",
  "LogView_details_created_by": "Created by {name}",
  "LogView_details_updated_at": "Last update at {date}",
  "LogView_details_last_edited_by": "Last edited by {name}",
  "LogView_details_last_edited": "Last edited",
  "LogView_label_auto": "auto",
  "LogView_label_default": "default",
  "LogView_label_manual": "manual",
  "LogView_label_nmea": "nmea",
  "LogView_log_alert": "Alert {status}: {type} {info}",
  "LogView_log_alert_info_anchorDepth": "- {depth}",
  "LogView_log_alert_info_anchorDrift": "- drifted {distance} from anchor point",
  "LogView_log_alert_info_pressure": "- {action} by {delta} in {interval}",
  "LogView_log_alert_info_pressure_drop": "dropped",
  "LogView_log_alert_info_pressure_raise": "increased",
  "LogView_log_alert_anchorDrift": "Anchor drift",
  "LogView_log_alert_depth": "Depth",
  "LogView_log_alert_lights": "Visual signals",
  "LogView_log_alert_lostPosition": "Lost position",
  "LogView_log_alert_manOverboard": "Man overboard",
  "LogView_log_alert_message": "Message",
  "LogView_log_alert_pressure": "Pressure",
  "LogView_log_alert_test": "Test",
  "LogView_log_alert_wind": "Wind",
  "LogView_log_alert_start": "Alert {alert} is {status}",
  "LogView_log_alert_triggered": "{alert} alert triggered",
  "LogView_log_alert_anchorDrift_detail": "{transition}: {problem}",
  "LogView_log_alert_depth_detail": "{transition}: {problem}",
  "LogView_log_alert_lostPosition_detail": "{transition}: {problem}",
  "LogView_log_alert_manOverboard_detail": "{transition}: {problem}",
  "LogView_log_alert_message_detail": "{transition}: {problem}",
  "LogView_log_alert_lostPosition_disconnected": "NMEA disconnected",
  "LogView_log_alert_lostPosition_stale": "position data is stale",
  "LogView_log_alert_lostPosition_jump": "implausible position jump",
  "LogView_log_alert_lostPosition_invalidFix": "invalid GPS fix",
  "LogView_log_alert_manOverboard_emitterActivated": "MOB beacon activated",
  "LogView_log_alert_manOverboard_manualButtonActivated": "MOB button activated",
  "LogView_log_alert_manOverboard_manual": "manually triggered",
  "LogView_log_alert_manOverboard_unknown": "MOB signal received",
  "LogView_log_alert_lights_detail": "{recorded} -> {recommended}: {transition}.",
  "LogView_log_alert_escalated": "{alert} alert escalated",
  "LogView_log_alert_escalated_by": "{alert} alert escalated to the skipper by {name}",
  "LogView_log_alert_snoozed": "{alert} alert snoozed",
  "LogView_log_alert_snoozed_by": "{alert} alert snoozed by {name}",
  "LogView_log_alert_acknowledged": "{alert} alert acknowledged",
  "LogView_log_alert_acknowledged_by": "{alert} alert acknowledged by {name}",
  "LogView_log_alert_cleared": "{alert} alert cleared",
  "LogView_log_alert_cleared_by": "{alert} alert cleared by {name}",
  "LogView_log_alert_resolved": "{alert} alert resolved",
  "LogView_log_alert_status_acknowledged": "Acknowledged",
  "LogView_log_alert_status_alarm": "Alarm",
  "LogView_log_alert_status_ignored": "Ignored",
  "LogView_log_alert_status_ok": "OK",
  "LogView_log_alert_status_resolved": "Resolved",
  "LogView_log_alert_status_warning": "Warning",
  "LogView_log_alert_type_anchorDepth": "Anchor depth",
  "LogView_log_alert_type_anchorDrift": "Anchor drift",
  "LogView_log_alert_type_pressure": "Pressure",
  "LogView_log_auto_interval": "Automatic entry after {duration}",
  "LogView_log_change_add_crew": "Added to Crew: {name}",
  "LogView_log_change_add_passengers": "Added to Passengers: {name}",
  "LogView_log_change_add_skipper": "Added to Skipper: {name}",
  "LogView_log_change_remove_crew": "Removed from Crew: {name}",
  "LogView_log_change_remove_passengers": "Removed from Passengers: {name}",
  "LogView_log_change_remove_skipper": "Removed from Skipper: {name}",
  "LogView_log_course_change": "Change of course",
  "LogView_log_course_change_active": "Course changed by {angle} {side} over {duration} to {course}",
  "LogView_log_course_change_end": "Course changed by {angle} {side} over {duration} from {course}",
  "LogView_log_course_change_side_port": "to port",
  "LogView_log_course_change_side_starboard": "to starboard",
  "LogView_log_course_change_started": "Course change started",
  "LogView_log_engine_start": "Started engine",
  "LogView_log_engine_start_name": "Started engine {name}",
  "LogView_log_engine_start_idle": "Started engine idling",
  "LogView_log_engine_start_idle_name": "Started engine {name} idling",
  "LogView_log_engine_stop": "Stopped engine",
  "LogView_log_engine_stop_name": "Stopped engine {name}",
  "LogView_log_engine_stop_duration": "Stopped engine after {duration}",
  "LogView_log_engine_stop_duration_name": "Stopped engine {name} after {duration}",
  "LogView_log_engine_stop_distance": "Stopped engine after {duration} ({distance})",
  "LogView_log_engine_stop_distance_name": "Stopped engine {name} after {duration} ({distance})",
  "LogView_log_engine_idle": "Engine idling",
  "LogView_log_engine_idle_name": "Engine {name} idling",
  "LogView_log_engine_load": "Engine under load",
  "LogView_log_engine_load_name": "Engine {name} under load",
  "LogView_log_engine_load_duration": "Engine under load after {duration}",
  "LogView_log_engine_load_duration_name": "Engine {name} under load after {duration}",
  "LogView_log_engine_missing": "Engine information missing, presumed stopped",
  "LogView_log_engine_missing_name": "Engine {name} information missing, presumed stopped",
  "LogView_log_engine_missing_duration": "Engine information missing, presumed stopped after {duration}",
  "LogView_log_engine_missing_duration_name": "Engine {name} information missing, presumed stopped after {duration}",
  "LogView_log_engine_missing_distance": "Engine information missing, presumed stopped after {duration} ({distance})",
  "LogView_log_engine_missing_distance_name": "Engine {name} information missing, presumed stopped after {duration} ({distance})",
  "LogView_log_propulsion_off": "Under sail, no engine running",
  "LogView_log_propulsion_off_noSails": "No engine running",
  "LogView_log_engine_missing_hint_castOff": "Engine entry missing since casting off?",
  "LogView_log_engine_missing_hint_anchorUp": "Engine entry missing since weighing anchor?",
  "LogView_log_engine_missing_hint_motorVessel": "Engine entry missing since getting underway?",
  "LogView_log_generator_start": "Started generator {number}",
  "LogView_log_generator_stop": "Stopped generator {number}",
  "LogView_log_lighting": "Lighting set to {lighting}",
  "LogView_log_lighting_none": "No lights shown",
  "LogView_log_monitor_start": "Started monitor {monitor}",
  "LogView_log_monitor_stop": "Stopped monitor {monitor}",
  "LogView_log_monitor_anchor": "Anchor Alarm",
  "LogView_log_monitor_depth": "Depth watch",
  "LogView_log_navigation_status_start": "Navigation started",
  "LogView_log_navigation_status_stop": "Navigation stopped",
  "LogView_log_nmea_connection_resume": "Resumed NMEA connection for Navigation data",
  "LogView_log_nmea_connection_stop": "Lost NMEA connection for Navigation data",
  "LogView_log_nmea_connection_start": "Started NMEA connection for",
  "LogView_log_nmea_connection_user_stop": "Closed NMEA connection for Navigation data",
  "LogView_log_pause_start": "Start of pause",
  "LogView_log_pause_stop": "End of pause",
  "LogView_log_pause_stop_duration": "End of pause after {duration}",
  "LogView_log_pause_stop_status": "{status} ended",
  "LogView_log_pause_stop_status_duration": "{status} ended after {duration}",
  "LogView_log_status_anchor": "At anchor",
  "LogView_log_status_bunkering": "At fuel station",
  "LogView_log_status_buoy": "At buoy",
  "LogView_log_status_drifting": "Drifting",
  "LogView_log_status_inmotion": "In motion",
  "LogView_log_status_offboard": "Offboard",
  "LogView_log_status_onboard": "Onboard",
  "LogView_log_status_port": "In port",
  "LogView_log_status_lock": "In lock",
  "LogView_log_status_bridge": "At bridge",
  "LogView_log_status_waiting": "Waiting",
  "LogView_log_status_location": "{status}: {location}",
  "LogView_log_stop": "Stopped for {stop}",
  "LogView_log_stop_location": "Stopped for {stop} at {location}",
  "LogView_log_stop_type_endOfDay": "end of day",
  "LogView_log_stop_type_stopover": "stopover",
  "LogView_log_sail_down": "{sail} down",
  "LogView_log_sail_up": "{sail} up",

  "LogView_nmea_auto_course_change_entries": "Course change entries",
  "LogView_nmea_auto_entries": "Auto entries",
  "LogView_nmea_pending": "Log",
  "LogView_provisional_cancel_discard": "Discard entry",
  "LogView_provisional_cancel_error": "The entry could not be discarded. Please try again.",
  "LogView_provisional_cancel_keep": "Keep",
  "LogView_provisional_cancel_message_courseChange": "Discard this course change? No entry will be recorded for this manoeuvre.",
  "LogView_provisional_cancel_message_speedChange": "Discard this pause? No entry will be recorded and the ship stays under way.",
  "LogView_provisional_cancel_title_courseChange": "Discard course change",
  "LogView_provisional_cancel_title_speedChange": "Discard pause",
  "LogView_tab_environment": "Environment",
  "LogView_tab_navigation": "Navigation",
  "LogView_tab_watch": "Watch",

  "LoginView": "",
  "LoginView_error_confirmation_failed": "Email confirmation failed. If the account was previously activated you can use the Forgot password function below.",
  "LoginView_error_failed": "Login failed. Please verify your email and password and try again.",
  "LoginView_error_failed_request": "Login failed. Please verify your internet connection and try again.",
  "LoginView_error_native_login_failed": "Sign in could not be completed. Please return to the app and try again.",
  "LoginView_local_login_required": "Open LOGBOOK on this device to sign in. Primary sign-in is only available on this device's local app.",
  "LoginView_companion_handoff_failed": "The companion connection could not be completed. Open LOGBOOK on this device and reconnect from your ship list.",
  "LoginView_companion_handoff_pending": "Connecting to the primary LOGBOOK...",
  "LoginView_error_native_login_invalid": "Sign in cannot continue because the app callback is missing or invalid.",
  "LoginView_error_signup_failed": "Signup failed.",
  "LoginView_error_signupEmailAlreadyExists": "Signup failed. Email address is already in use.",
  "LoginView_error_signupAccountAlreadyExists": "Signup failed. Account with the same name already exists.",
  "LoginView_error_signupNameInvalid": "Please enter your name (at least 3 characters).",
  "LoginView_error_signupEmailInvalid": "Please enter a valid email address.",
  "LoginView_error_signupPasswordInvalid": "Password must be at least 3 characters long.",
  "LoginView_error_invitation_accept_failed": "Accepting the invitation failed. Please make sure you are logged in with the account the invitation was sent to and try again.",
  "LoginView_forgot_password": "Password recovery",
  "LoginView_forgot_password_complete": "Password changed. You can now login to your account using the new password.",
  "LoginView_forgot_password_email": "Please enter the email address of your account to start the password recovery process.",
  "LoginView_forgot_password_email_sent": "If an account exists for this email address, you will receive an email with the next steps.",
  "LoginView_forgot_password_new_password": "Please enter a new password to complete the password recovery.",
  "LoginView_error_reset_failed": "Password recovery failed. Please try again.",
  "LoginView_error_reset_failed_request": "Password recovery failed. Please verify your internet connection and try again.",
  "LoginView_form_back_to_login": "Return to login",
  "LoginView_form_name": "Name",
  "LoginView_form_email": "Email",
  "LoginView_form_new_password": "New password",
  "LoginView_form_new_password_confirmation": "New password confirmation",
  "LoginView_form_password": "Password",
  "LoginView_form_submit": "Login",
  "LoginView_form_submit_forgot_password": "Reset",
  "LoginView_form_submit_forgot_password_loading": "Resetting…",
  "LoginView_form_submit_login": "Login",
  "LoginView_form_submit_login_loading": "Logging in…",
  "LoginView_form_submit_signup": "Signup",
  "LoginView_form_forgot_password": "Forgot\u00A0password?",
  "LoginView_form_account_name": "Account name",

  "LoginView_reset_app_title": "Reset App",
  "LoginView_reset_app_cancel": "Cancel",
  "LoginView_reset_app_action": "Start reset",

  "LoginView_welcome": "Welcome to LOGBOOK.",
  "LoginView_signup_link_unavailable": "The signup link could not be loaded. Please try again.",
  "LoginView_signup_link_retry": "Try again",
  "LoginView_login": "You already have an account? Just login to LOGBOOK.",
  "LoginView_login_email": "Login with your email and password.",
  "LoginView_native_sign_in_loading": "Signing in…",
  "LoginView_native_sign_in_fallback": "Sign in with Safari",
  "LoginView_native_sign_in_or": "or",
  "LoginView_signup": "You are new to LOGBOOK? Just signup for LOGBOOK.",
  "LoginView_signup_email": "Signup with your email and a password.",
  "LoginView_invitation_use_other_account": "Use other account",
  "LoginView_invitation_accept": "Accept invitation",
  "LoginView_footer_about": "About us",
  "LoginView_footer_help": "Help",
  "LoginView_footer_language": "Language",
  "LoginView_footer_reset_app": "Reset App",

  "Menu": "",
  "Menu_ship": "Ship",
  "Menu_account": "Account",

  "MenuAccount": "",
  "MenuAccount_account_settings": "Account\u00A0Settings",
  "MenuAccount_remove_account": "Remove account",
  "MenuAccount_close_companion": "Disconnect Companion",
  "MenuAccount_open_cloud": "To LOGBOOK\u00A0Cloud",
  "MenuAccount_account_settings_app": "To LOGBOOK\u00A0App",
  "MenuAccount_logout": "Logout",
  "MenuAccount_switch_user": "Switch User",
  "MenuAccount_return_to_own_user": "Return to {name}",
  "MenuAccount_user_settings": "User\u00A0Settings",

  "MenuHelp": "",
  "MenuHelp_about": "About\u00A0LOGBOOK",
  "MenuHelp_change_log": "Change Log",
  "MenuHelp_contact_support": "Contact\u00A0support",
  "MenuHelp_documentation": "Documentation",
  "MenuHelp_help": "Help",
  "MenuHelp_support": "Support Page",
  "MenuHelp_qanda": "Questions & Answers",
  "MenuHelp_demo": "Interactive Demos",
  "MenuHelp_title": "Help",

  "MenuAlerts": "",
  "MenuAlerts_title": "Alerts",

  "MenuNMEA": "",
  "MenuNMEA_connection": "NMEA connection",
  "MenuNMEA_last_update": "Last update: {timestamp}",
  "MenuNMEA_recording": "Automatic logging",
  "MenuNMEA_settings": "Settings",
  "MenuNMEA_title": "NMEA",

  "MenuShip": "",
  "MenuShip_close": "Close LOGBOOK {name}",
  "MenuShip_logout": "Logout from \"{name}\"",
  "MenuShip_data_name": "{name} Ship data",
  "MenuShip_new": "New Ship",
  "MenuShip_settings_name": "{name} Settings",
  "MenuShip_select": "Select Ship",
  "MenuShip_view_cloud": "View \"{name}\" in Cloud",
  "MenuShip_view_ships": "View Ships list",

  "MenuSync": "",
  "MenuSync_internet_status": "Internet\u00A0connection",
  "MenuSync_last_update": "Last update: {timestamp}",
  "MenuSync_status": "Sync status",
  "MenuSync_title": "Sync",
  "MenuSync_resync": "Reconnect",
  "MenuSync_relogin": "Log in again",

  "NMEAConfigurationView": "",
  "NMEAConfigurationView_blank": "\u00A0",
  "NMEAConfigurationView_and": "and",
  "NMEAConfigurationView_banner_start_setup": "Start NMEA setup",
  "NMEAConfigurationView_banner_text": "NMEA Connection is not enabled.",
  "NMEAConfigurationView_cancel": "Cancel",
  "NMEAConfigurationView_checks": "Available NMEA data:",
  "NMEAConfigurationView_check_air_pressure": "Air pressure",
  "NMEAConfigurationView_check_air_humidity": "Humidity",
  "NMEAConfigurationView_check_air_temperature": "Air temperature",
  "NMEAConfigurationView_check_depth": "Depth",
  "NMEAConfigurationView_check_engine": "Engine RPM",
  "NMEAConfigurationView_check_engine_1": "Engine #1 RPM",
  "NMEAConfigurationView_check_engine_2": "Engine #2 RPM",
  "NMEAConfigurationView_check_engine_3": "Engine #3 RPM",
  "NMEAConfigurationView_check_engine_4": "Engine #4 RPM",
  "NMEAConfigurationView_check_engine_5": "Engine #5 RPM",
  "NMEAConfigurationView_check_engine_ids": "Active Engine IDs: {ids}",
  "NMEAConfigurationView_check_engine_ids_none": "none",
  "NMEAConfigurationView_check_navigation_course": "Heading",
  "NMEAConfigurationView_check_navigation_gps": "GPS position",
  "NMEAConfigurationView_check_navigation_log": "Distance through water",
  "NMEAConfigurationView_check_navigation_sog": "Speed over ground",
  "NMEAConfigurationView_check_utc": "UTC",
  "NMEAConfigurationView_check_water_temperature": "Water temperature",
  "NMEAConfigurationView_check_native_gps": "Internal GPS position",
  "NMEAConfigurationView_check_native_air_pressure": "Internal air pressure",
  "NMEAConfigurationView_check_wind": "Wind (speed and direction)",
  "NMEAConfigurationView_connection_device": "Device",
  "NMEAConfigurationView_connection_host": "Address",
  "NMEAConfigurationView_connection_port": "Port",
  "NMEAConfigurationView_connection_type": "NMEA connection type",
  "NMEAConfigurationView_connection_type_bluetooth": "Bluetooth (unsupported)",
  "NMEAConfigurationView_connection_type_gps": "Built-in GPS",
  "NMEAConfigurationView_connection_type_tcp": "TCP",
  "NMEAConfigurationView_connection_type_udp": "UDP",
  "NMEAConfigurationView_connection_type_usb": "USB",
  "NMEAConfigurationView_connect": "Test Connection",
  "NMEAConfigurationView_connecting": "Connecting...",
  "NMEAConfigurationView_capture": "Send NMEA Data to Support",
  "NMEAConfigurationView_capture_sending": "Sending...",
  "NMEAConfigurationView_capture_success": "Sent",
  "NMEAConfigurationView_capture_error": "Sending failed",
  "NMEAConfigurationView_capture_hint": "Sends a short recording of the raw data received from your instruments, so support can analyze connection problems.",
  "NMEAConfigurationView_complete": "Complete",
  "NMEAConfigurationView_error_invalidUrl": "Error: Invalid URL",
  "NMEAConfigurationView_error_connectionFailed": "Error: Connection failed",
  "NMEAConfigurationView_error_disconnected": "Error: NMEA is not connected",
  "NMEAConfigurationView_error_failedToOpen": "Error: Failed to open device",
  "NMEAConfigurationView_error_subscriptionExpired": "Error: Subscription expired",
  "NMEAConfigurationView_error_unsupportedSchema": "Error: Unsupported Protocol",
  "NMEAConfigurationView_reconnect": "Reconnect",
  "NMEAConfigurationView_reset": "Reset",
  "NMEAConfigurationView_step_conditions": "Conditions",
  "NMEAConfigurationView_step_connection": "Connection",
  "NMEAConfigurationView_step_native": "Internal sensors",
  "NMEAConfigurationView_step_test_data": "Test and Data",
  "NMEAConfigurationView_title": "NMEA Settings",
  "NMEAConfigurationView_read_more": "Read more",
  "NMEAConfigurationView_condition_entry": "Conditions for automatic log entries",
  "NMEAConfigurationView_condition_interval": "Regular entries every ",
  "NMEAConfigurationView_condition_interval_3600": "60 min ",
  "NMEAConfigurationView_condition_interval_1800": "30 min ",

  "NMEAConfigurationView_condition_start_stop": "Condition for Start/Stop entry",
  "NMEAConfigurationView_condition_anchor_start_stop": "Different setting when at anchor or buoy",
  "NMEAConfigurationView_condition_anchor_no_status_change": "No status change when speed is",
  "NMEAConfigurationView_condition_anchor_depth_alerts": "Anchor & Depth Alerts",
  "NMEAConfigurationView_condition_anchor_drift_warning": "Anchor drift warning (nm)",
  "NMEAConfigurationView_condition_anchor_drift_alarm": "Anchor drift alarm (nm)",
  "NMEAConfigurationView_condition_depth_warning": "Depth warning",
  "NMEAConfigurationView_condition_depth_alarm": "Depth alarm",
  "NMEAConfigurationView_condition_stop": "Stop entry when speed is",
  "NMEAConfigurationView_condition_start": "Start entry when speed is",
  "NMEAConfigurationView_condition_course": "Entry on course change when ",
  "NMEAConfigurationView_condition_course_change": "course change is",
  "NMEAConfigurationView_condition_course_speed": "speed is",
  "NMEAConfigurationView_condition_native_gps": "Use internal GPS",
  "NMEAConfigurationView_condition_native_pressure": "Use internal air pressure sensor",
  "NMEAConfigurationView_condition_engine_idle_rpm": "If engine is running with less than idle speed (rpm): count time and distance as \"under sails\".",
  "NMEAConfigurationView_condition_engine_idle_rpm_value": "idle speed (rpm)",
  "NMEAConfigurationView_condition_engine_detection": "Engine detection (rpm)",
  "NMEAConfigurationView_condition_engine_start": "Engine running when rpm is",
  "NMEAConfigurationView_condition_engine_stop": "Engine off when rpm is",
  "NMEAConfigurationView_error_engine_rpm_order": "Error: Engine off rpm must be below engine running rpm",
  "NMEAConfigurationView_error_engine_idle_rpm": "Error: Idle speed must be above engine running rpm",
  
  "NoteView": "",
  "NoteView_planning": "Voyage plan",
  "NoteView_crew": "Crew",
  "NoteView_day": "Day",
  "NoteView_file_field_drag_drop": "Attach files to this note.",
  "NoteView_attachment_remove_confirm": "Do you really want to remove this attachment?",
  "NoteView_attachment_remove_title": "Remove attachment",
  "NoteView_attachment_remove_accept": "Remove",
  "NoteView_attachment_remove_cancel": "Cancel",
  "NoteView_attachment_remove_error": "Could not remove the attachment. Please try again.",
  "NoteView_journal": "Journal",
  "NoteView_note_created_by": "Created by {name}",
  "NoteView_note_parent_day": "Day: {date}",
  "NoteView_note_parent_trip": "Passage: {name}",
  "NoteView_other": "Other",
  "NoteView_technical": "Technical",
  "NoteView_type": "Type",
  "NoteView_weather": "Weather forecast",
  "NoteView_show_notes": "Show {count} {type} notes",
  "NoteView_watch": "Watch plan",

  "NoteView_note_add_new": "Add new note",

  "NoteView_note_journal_title": "Journal entry title",
  "NoteView_note_journal_note": "Journal text",

  "NoteView_note_planning_date": "Date",
  "NoteView_note_planning_title": "Location",
  "NoteView_note_planning_note": "Comment",

  "NoteView_note_technical_title": "Technical note title",
  "NoteView_note_technical_note": "Technical note",

  "NoteView_note_parent_type_day": "day",
  "NoteView_note_parent_type_trip": "passage",

  "NoteView_note_weather_title": "Source",
  "NoteView_note_weather_date": "Date and time",
  "NoteView_note_weather_note": "Weather forecast",
  "NoteView_note_weather_note_extra": "Weather conditions",

  "PrintHeaderView": "",
  "PrintHeaderView_title": "LOGBOOK {view} – {ship}",
  "PrintHeaderView_print_1": "Voyage Overview",
  "PrintHeaderView_print_2": "Selected Passages",
  "PrintHeaderView_print_3": "Selected Days",
  "PrintHeaderView_print_4": "Ship data",
  "PrintHeaderView_motor": "Motor vessel",
  "PrintHeaderView_sailing": "Sailing vessel",

  "PrintSettingsView": "",
  "PrintSettingsView_title": "Print Settings",
  "PrintSettingsView_button": "Print",
  "PrintSettingsView_cancel": "Cancel",
  "PrintSettingsView_overview": "Print Overview",
  "PrintSettingsView_overview_all": "Print all Voyages in LOGBOOK",
  "PrintSettingsView_overview_year": "Select a year",
  "PrintSettingsView_overview_cruises": "Print Overview of Voyages",

  "PrintSettingsView_cruise": "Print Voyage",
  "PrintSettingsView_cruise_current": "Print all data of the Voyage followed by a list of all Passages",
  "PrintSettingsView_cruise_summary": "Voyage data and list of Passages",
  "PrintSettingsView_cruise_details": "Voyage details",

  "PrintSettingsView_ship": "Print Ship Data",
  "PrintSettingsView_ship_short": "Main Ship Data",
  "PrintSettingsView_ship_details": "Detailed Ship Data",
  "PrintSettingsView_user_list": "Print all People for this Ship",

  "PrintSettingsView_trip": "Passages",
  "PrintSettingsView_trips": "Print Passages",
  "PrintSettingsView_trips_all": "Print all Passages of the Voyage",
  "PrintSettingsView_trips_selected": "Select a Passage to print",
  "PrintSettingsView_timeline": "Timeline",
  "PrintSettingsView_trips_summary": "Print all data of the Passages and",
  "PrintSettingsView_trips_summary_details": "a list of Days with Details",
  "PrintSettingsView_trips_summary_short": "a short list of Days",
  "PrintSettingsView_trips_details": "Passage details",
  "PrintSettingsView_journal_list": "Print all Journal entries (Passages and Days)",
  "PrintSettingsView_technical_list": "Print all Technical entries (Passages and Days)",

  "PrintSettingsView_days": "Print Days",
  "PrintSettingsView_days_select": "Select a single Day",
  "PrintSettingsView_days_trip_select": "Print all Days of selected Passage",
  "PrintSettingsView_days_text": "Print data of the Day: tabs Day and Statistics plus the tabs chosen below:",
  "PrintSettingsView_thumbnails": " (incl. image thumbnails)",

  "PrintSettingsView_entries": "Also append Log Entries to each Day",
  "PrintSettingsView_edits": "Include all edits to Log Entries and on the tap for the Day",
  "PrintSettingsView_entries_summary": "Summary (list of Log Entries)",
  "PrintSettingsView_entries_details": "Detailed Log Entries",
  "PrintSettingsView_entries_day_select": "Select a Day",
  "PrintSettingsView_entries_trip_select": "Select a Passage for printing Days from",

  "PrintSettingsView_evaluations": "Print Evaluations",
  "PrintSettingsView_journal": "Journal entries with photos",
  "PrintSettingsView_tacks": "Tracks",
  "PrintSettingsView_technical": "Technical documentation with photos",

  "PrintSettingsView_authorities": "Evaluation for authorities",
  "PrintSettingsView_authorities_day": "Manual entries for the day",
  "PrintSettingsView_authorities_log": "Log entries",

  "PrintView": "",
  "PrintView_print_action": "Print",
  "PrintView_print_cancel": "Cancel",
  "PrintView_cruise": "Voyage",
  "PrintView_cruise_statistics": "Statistics of the Voyage",
  "PrintView_trip": "Passage",
  "PrintView_trips": "Passage",

  "PrintView_trip_list": "List of Passages",
  "PrintView_trip_statistics": "Statistics of the Passage",
  "PrintView_day": "Logbook Data for",
  "PrintView_day_list": "List of Days in the Passage",
  "PrintView_day_maindata": "Main data of the Day",
  "PrintView_day_statistics": "Statistics of the Day",
  "PrintView_date": "Date",
  "PrintView_from_date": "From",
  "PrintView_until_date": "until",
  "PrintView_from_loc": "Traveling from",
  "PrintView_to_loc": "to",
  "PrintView_time_total": "Time",
  "PrintView_distance_total": "Distance",
  "PrintView_technical_notes": "Technical Notes",

  "PrintView_watch_groups": "Watch Groups",
  "PrintView_watch_shifts": "Watch Shifts",

  "PrintView_note_technical": "Technical Note",
  "PrintView_list_technical": "List of all Technical Notes",
  "PrintView_note_journal": "Journal Entry",
  "PrintView_list_journal": "List of all Journal Entries",

  "PrintView_note_watch": "Watch",
  "PrintView_note_planning": "Voyage Plan",
  "PrintView_note_weather": "Weather Forecast",

  "PrintView_log_entries": "Log Entries",

  "SearchView": "",
  "SearchView_token_ship": "Ship",
  "SearchView_token_type": "Type",
  "SearchView_type_cruise": "Voyage",
  "SearchView_type_day": "Day",
  "SearchView_type_log": "Log",
  "SearchView_type_note": "Note",
  "SearchView_type_trip": "Passage",

  "ShipImportView": "",
  "ShipImportView_cancel": "Cancel",
  "ShipImportView_file_field_drag_drop": "Select LogbookSuite export file",
  "ShipImportView_open": "View Ship",
  "ShipImportView_status_complete": "Complete",
  "ShipImportView_status_failed": "Failed. Please try again or contact support for assistance.",
  "ShipImportView_status_error": "Fehler: {error}",
  "ShipImportView_status_processing": "Processing",
  "ShipImportView_status_pending": "Preparing to import",
  "ShipImportView_status_uploading": "Uploading",
  "ShipImportView_title": "Import Ship data",
  "ShipImportView_title_ship": "Import passages into {ship}",

  "ShipSettingsView_settings": "Settings",
  "ShipSettingsView_ship_settings": "Ship Settings",
  "ShipSettingsView_tab_units": "Settings for units",
  "ShipSettingsView_tab_ship_user": "All People",
  "ShipSettingsView_tab_lists": "Settings for lists",
  "ShipSettingsView_tab_settings": "Settings",
  "ShipSettingsView_tab_companions": "Companions",
  "ShipSettingsView_more_info": "Learn more", 
  "ShipSettingsView_read_more": "Read more", 
  "ShipSettingsView_add_user": "Person",
  "ShipSettingsView_cancel": "Cancel",
  "ShipSettingsView_save": "Add Person",
  "ShipSettingsView_timezone": "Timezone",
  "ShipSettingsView_timezone_title": "Manual Setup of the Timezone",
  "ShipSettingsView_timezone_manual": "Set Timezone manually",
  "ShipSettingsView_current_time": "Current Time",
  "ShipSettingsView_log_offset_title": "Offset for Value from Log Transducer",
  "ShipSettingsView_log_offset": "Log Offset (nm)",
  "ShipSettingsView_rpm_title": "Keep manually entered RPM",
  "ShipSettingsView_rpm_keep_manual": "Carry over RPM to next log entry",
  "ShipSettingsView_lights_title": "Visual signals reminder",
  "ShipSettingsView_lights_enable": "Remind me about the visual signals",
  "ShipSettingsView_lights_sailing": "Lights carried when sailing",
  "ShipSettingsView_lights_sailing_runningLights": "Separate running lights",
  "ShipSettingsView_lights_sailing_triColor": "Masthead tri-colour light",
  "ShipSettingsView_lights_lead": "Day / night boundary",
  "ShipSettingsView_lights_lead_civil": "Civil twilight (recommended)",
  "ShipSettingsView_lights_lead_official": "Sunset / sunrise",
  "ShipSettingsView_lights_motoring_cone": "Remind me to hoist the motoring cone",
  "ShipSettingsView_edit_permissiveness_title": "Editing permissiveness",
  "ShipSettingsView_edit_permissiveness_level": "Editing level",
  "ShipSettingsView_edit_permissiveness_level_default": "Default (strict)",
  "ShipSettingsView_edit_permissiveness_level_extended": "Extended",
  "ShipSettingsView_edit_permissiveness_level_unrestricted": "Unrestricted",
  "ShipSettingsView_socket": "Address of the Primary LOGBOOK",
  "ShipSettingsView_socket_text": "Use this address to connect a Companion to the Primary LOGBOOK",
  "ShipSettingsView_connected_companions": "Connected companions",
  "ShipSettingsView_companion_host": "Host",
  "ShipSettingsView_companion_user": "User",
  "ShipSettingsView_companions_loading": "Loading connected companions…",
  "ShipSettingsView_companions_empty": "No companions are currently connected.",
  "ShipSettingsView_companions_error": "Could not load connected companions. Retrying…",
  "ShipSettingsView_disconnect_companion": "Disconnect",
  "ShipSettingsView_disconnect_companion_label": "Disconnect {user} at {host}",
  "ShipSettingsView_disconnect_companion_title": "Disconnect companion?",
  "ShipSettingsView_disconnect_companion_text": "This companion will need to reconnect manually. The user's ship permissions and other devices will not change.",
  "ShipSettingsView_disconnect_companion_error": "Could not disconnect this companion. Please try again.",

  "ShipSettingsView_units": "Settings for units",

  "ShipSettingsView_comment_": "*Choose or enter*",
  "ShipSettingsView_seaState_": "*Choose or enter*",

  "ShipSettingsView_comment_anchor_down": "Anchor down",
  "ShipSettingsView_comment_anchor_up": "Anchor up",
  "ShipSettingsView_comment_engine_started": "Engine started",
  "ShipSettingsView_comment_engine_stopped": "Engine stopped",
  "ShipSettingsView_comment_sails_set": "Sails setup",
  "ShipSettingsView_comment_sails_dropped": "Sails dropped",

  "ShipSettingsView_add_seaState": "Add sea state",
  "ShipSettingsView_add_comment": "Add comment",

  "ShipSettingsView_seaState_waves": "Waves",
  "ShipSettingsView_seaState_swell": "Swell",
  "ShipSettingsView_seaState_cross_sea": "Cross sea",
  "ShipSettingsView_seaState_calm": "Calm sea",
  "ShipSettingsView_seaState_rough": "Rough sea",

  "ShipSettingsView_currency": "Currency",
  "ShipSettingsView_distance": "Distance",
  "ShipSettingsView_length": "Length",
  "ShipSettingsView_power": "Power",
  "ShipSettingsView_pressure": "Pressure",
  "ShipSettingsView_speed": "Speed",
  "ShipSettingsView_surface": "Surface",
  "ShipSettingsView_temperature": "Temperature",
  "ShipSettingsView_volume": "Volume",
  "ShipSettingsView_weight": "Weight",
  "ShipSettingsView_wind": "Wind",
  "ShipSettingsView_current": "Current",
  "ShipSettingsView_unit_currency": "Currency",

  "ShipSettingsView_unit_bar": "bar",
  "ShipSettingsView_unit_celsius": "°C",
  "ShipSettingsView_unit_cm": "cm",
  "ShipSettingsView_unit_fahrenheit": "°F",
  "ShipSettingsView_unit_foot": "foot",
  "ShipSettingsView_unit_gal": "gal",
  "ShipSettingsView_unit_inch": "inch",
  "ShipSettingsView_unit_kg": "kg",
  "ShipSettingsView_unit_km": "km",
  "ShipSettingsView_unit_kmh": "km/h",
  "ShipSettingsView_unit_kn": "kn",
  "ShipSettingsView_unit_kw": "kw",
  "ShipSettingsView_unit_kwh": "kwh",
  "ShipSettingsView_unit_hp": "hp",
  "ShipSettingsView_unit_l": "l",
  "ShipSettingsView_unit_m3": "m³",
  "ShipSettingsView_unit_cuft": "cuft",
  "ShipSettingsView_unit_mps": "m/s",
  "ShipSettingsView_unit_m": "m",
  "ShipSettingsView_unit_m2": "m²",
  "ShipSettingsView_unit_miles": "miles",
  "ShipSettingsView_unit_mph": "mph",
  "ShipSettingsView_unit_nm": "nm",
  "ShipSettingsView_unit_lb": "lb",
  "ShipSettingsView_unit_ft": "ft",
  "ShipSettingsView_unit_in": "in",
  "ShipSettingsView_unit_sqft": "sqft",
  "ShipSettingsView_unit_psi": "psi",
  "ShipSettingsView_unit_sqyd": "sqyd",
  "ShipSettingsView_unit_tons": "to",
  "ShipSettingsView_unit_yard": "yard",
  "ShipSettingsView_unit_hpa": "hPa",

  "ShipSettingsView_unit_undefined": "*Choose or enter*",
  "ShipSettingsView_other": "Enter other",

  "ShipSettingsView_unit_eur": "€",
  "ShipSettingsView_unit_usd": "$",
  "ShipSettingsView_unit_gbp": "£",
  "ShipSettingsView_unit_aud": "AU$",
  "ShipSettingsView_unit_nzd": "NZ$",
  "ShipSettingsView_unit_chf": "CHF",
  "ShipSettingsView_unit_sek": "SEK",
  "ShipSettingsView_unit_nok": "NOK",
  "ShipSettingsView_unit_dkk": "DKK",
  "ShipSettingsView_unit_jpy": "¥",

  "ShipSettingsView_user_crew_role": "Crew role",
  "ShipSettingsView_ship_user_crew_role_crew": "Crew",
  "ShipSettingsView_ship_user_crew_role_none": "None",
  "ShipSettingsView_ship_user_crew_role_owner": "Account holder",
  "ShipSettingsView_ship_user_crew_role_skipper": "Skipper",
  "ShipSettingsView_user_email": "Email",
  "ShipSettingsView_language": "Language",
  "ShipSettingsView_lang_en": "English",
  "ShipSettingsView_lang_de": "Deutsch",
  "ShipSettingsView_lang_fr": "Français",
  "ShipSettingsView_user_name": "Name",
  "ShipSettingsView_user_shortname": "Short name",
  "ShipSettingsView_user_account": "Account",
  "ShipSettingsView_user_active": "Activate",
  "ShipSettingsView_user_inactive": "Deactivate",
  "ShipSettingsView_user_invite": "Invite",
  "ShipSettingsView_user_invite_title": "Invite Ship user to LOGBOOK",
  "ShipSettingsView_user_reactivate": "Reactivate",
  "ShipSettingsView_remove_user": "Remove",
  "ShipSettingsView_user_deactivate_confirm_title": "Deactivate user",
  "ShipSettingsView_user_deactivate_confirm_message": "Do you really want to deactivate this user's access to the ship? If they have no other ship access on this account, their account will be deactivated as well.",
  "ShipSettingsView_user_deactivate_confirm_accept": "Deactivate",
  "ShipSettingsView_user_deactivate_confirm_cancel": "Cancel",
  "ShipSettingsView_user_remove_confirm_title": "Remove user",
  "ShipSettingsView_user_remove_confirm_message": "Do you really want to remove this user from the ship? This cannot be undone.",
  "ShipSettingsView_user_remove_confirm_accept": "Remove",
  "ShipSettingsView_user_remove_confirm_cancel": "Cancel",

  "ShipSettingsView_ship_user_level": "Permissions",
  "ShipSettingsView_ship_user_level_primary": "Primary",
  "ShipSettingsView_ship_user_level_editAll": "View and edit all",
  "ShipSettingsView_ship_user_level_editCurrent": "View and edit current voyage",
  "ShipSettingsView_ship_user_level_viewAll": "View all",
  "ShipSettingsView_ship_user_level_viewCurrent": "View current voyage",
  "ShipSettingsView_ship_user_level_none": "None",

  "ShipSettingsView_user_status": "Status",
  "ShipSettingsView_user_status_active": "Active",
  "ShipSettingsView_user_status_invited": "Invited",
  "ShipSettingsView_user_status_undefined": " ",

  "ShipSettingsView_user_add_user": "Add person",
  "ShipSettingsView_add_user_with_permissions": "Add person with permissions for LOGBOOK",
  "ShipSettingsView_add_user_without_permissions": "Add person without permissons",
  "ShipSettingsView_users_with_level": "Ship users with permissions for LOGBOOK",
  "ShipSettingsView_users_without_level": "Persons without permissions",

  "ShipContentView": "",
  "ShipContentView_back": "Back",

  "ShipDataView": "",
  "ShipDataView_blank": "  ",
  "ShipDataView_": "*Choose*",
  "ShipDataView_add": "Add",
  "ShipDataView_ship_data": "Ship data",
  "ShipDataView_file_field_drag_drop": "Insert photos of your ship here.",

  "ShipDataView_general": "General Ship Data",
  "ShipDataView_choose": "*Choose or enter* ",
  "ShipDataView_other": "Enter other",

  "ShipDataView_tab_general": "General",
  "ShipDataView_tab_details": "Details",
  "ShipDataView_tab_technic": "Technic",
  "ShipDataView_tab_sailing": "Sailing",
  "ShipDataView_tab_equipment": "Equipment",
  "ShipDataView_tab_ship_user": "All persons",
  "ShipDataView_tab_units": "Units",

  "ShipDataView_callsign": "Callsign",
  "ShipDataView_imo": "IMO",
  "ShipDataView_mmsi": "MMSI",
  "ShipDataView_name": "Name",

  "ShipDataView_reg_number": "Registration number",
  "ShipDataView_hin": "HIN",
  "ShipDataView_flag": "Flag",
  "ShipDataView_home_port": "Home port",
  "ShipDataView_yacht_club": "Yacht club",
  "ShipDataView_yacht_club_address": "Address",

  "ShipDataView_model_name": "Model name",
  "ShipDataView_year": "Year build",
  "ShipDataView_yachtbuilder": "Yacht builder",
  "ShipDataView_designer": "Designer",
  "ShipDataView_construction": "Overall construction",
  "ShipDataView_build_number": "Build number",
  "ShipDataView_cel": "CEL category",
  "ShipDataView_cel_persons": "for persons",

  "ShipDataView_ship_foto": "Ship photo",

  "ShipDataView_inside": "Living area",
  "ShipDataView_berth_no": "No. berth total",
  "ShipDataView_berth_single_no": "No. single berth",
  "ShipDataView_berth_double_no": "No. double berth",
  "ShipDataView_berth_extra_no": "No. extra berth",
  "ShipDataView_cabins_no": "No. cabins",
  "ShipDataView_bath_no": "No. bathrooms",
  "ShipDataView_saloon": "Saloon",
  "ShipDataView_pantry": "Pantry",
  "ShipDataView_cabins": "Cabins",
  "ShipDataView_cockpit": "Cockpit",

  "ShipDataView_owner": "Owner",
  "ShipDataView_owner_name": "Name",
  "ShipDataView_owner_address": "Address",
  "ShipDataView_owner_phone": "Phone",
  "ShipDataView_owner_email": "Email",

  "ShipDataView_shape": "Shape",
  "ShipDataView_monohull": "Monohull",
  "ShipDataView_catamaran": "Catamaran",
  "ShipDataView_trimaran": "Trimaran",

  "ShipDataView_sailing-sloop": "Sailboat sloop",
  "ShipDataView_sailing-ketch": "Sailboat ketch",
  "ShipDataView_sailing-classic": "Sailboat classic",
  "ShipDataView_sailing-cat": "Sailboat catamaran",
  "ShipDataView_sailing-tri": "Sailboat trimaran",
  "ShipDataView_sailing-longkeeler": "Sailboat longkeeler",
  "ShipDataView_motor-boat": "Motorboat",
  "ShipDataView_motor-cat": "Motor catamaran",
  "ShipDataView_motor-tri": "Motor trimaran",
  "ShipDataView_motor-yacht": "Motor yacht",
  "ShipDataView_motor-superyacht": "Motor superyacht",
  "ShipDataView_special_features": "Special features",

  "ShipDataView_vessel_type": "Vessel type",

  "ShipDataView_dimensions": "Dimensions",
  "ShipDataView_height": "A: Height",
  "ShipDataView_draft": "B: Draft",
  "ShipDataView_length_waterline": "C: Length waterline",
  "ShipDataView_length_hull": "D: Length of hull",
  "ShipDataView_length": "E: Length over all",
  "ShipDataView_beam": "Beam",
  "ShipDataView_hull_material": "Material of the hull",
  "ShipDataView_hull_color": "Color of the hull",
  "ShipDataView_masts_no": "No. of masts",
  "ShipDataView_rig": "Shape of the rig",
  "ShipDataView_sail_area_total": "Sail area",
  "ShipDataView_comment": "Comment",

  "ShipDataView_displacement": "Displacement",
  "ShipDataView_keel_weight": "Keel weight",
  "ShipDataView_keel_material": "Keel material",
  "ShipDataView_ballast_percentage": "Ballast percentage",
  "ShipDataView_keel_shape": "Keel shape",
  "ShipDataView_keel_weight_percent": "Keel weight %",

  "ShipDataView_mast_rig": "Mast, rig and deck equipment",
  "ShipDataView_rig_elements": "Rig elements",
  "ShipDataView_rig_element": "Rig element",
  "ShipDataView_rig_mast": "Mast",
  "ShipDataView_rig_main_mast": "Main mast",
  "ShipDataView_rig_stay": "Toppstag",
  "ShipDataView_rig_mizzen_mast": "Mizzen mast",
  "ShipDataView_rig_forestay": "Forestay",
  "ShipDataView_rig_jib_stay": "Jib stay",
  "ShipDataView_rig_backstay": "Backstay",
  "ShipDataView_rig_runner": "Runner",
  "ShipDataView_rig_baby_stay": "Baby stay",
  "ShipDataView_rig_kicker": "Kicker",
  "ShipDataView_rig_vang": "Vang",
  "ShipDataView_rig_winch": "Winch",
  "ShipDataView_rig_": "*Choose or enter* ",
  "ShipDataView_rig_null": "*Choose or enter* ",

  "ShipDataView_unit_m": "m",
  "ShipDataView_unit_cm": "cm",
  "ShipDataView_unit_inch": "inch",
  "ShipDataView_unit_foot": "foot",
  "ShipDataView_unit_yard": "yard",
  "ShipDataView_unit_nm": "nm",

  "ShipDataView_unit_m2": "m²",
  "ShipDataView_unit_square_foot": "sqft",
  "ShipDataView_unit_square_yard": "sqyd",

  "ShipDataView_unit_pound": "lb",
  "ShipDataView_unit_kg": "kg",
  "ShipDataView_unit_tons": "to",

  "ShipDataView_unit_knots": "kn",
  "ShipDataView_unit_m_per_second": "m/s",
  "ShipDataView_unit_km_per_hour": "km/h",
  "ShipDataView_unit_kWh": "kWh",
  "ShipDataView_unit_kw": "kW",
  "ShipDataView_unit_hp": "hp",

  "ShipDataView_unit_l": "l",
  "ShipDataView_unit_gal": "gal",
  "ShipDataView_unit_liter": "l",
  "ShipDataView_unit_gallon": "gal",
  "ShipDataView_unit_celsius": "°C",
  "ShipDataView_unit_fahrenheit": "°F",

  "ShipDataView_other_equipment": "Other equipment",
  "ShipDataView_other_equipment_text": "Enter here all other equipment of the ship that could not be entered in the other areas, such as information on the dinghy etc.",

  "ShipDataView_add_engine": "Add engine",
  "ShipDataView_add_generator": "Add generator",
  "ShipDataView_add_sail": "Add sail",
  "ShipDataView_add_insurance": "Add insurance",
  "ShipDataView_add_anchor": "Add anchor",
  "ShipDataView_add_tank": "Add tank",
  "ShipDataView_add_steeringsystem": "Add steering system",
  "ShipDataView_add_other_equipment": "Add other equipment",
  "ShipDataView_add_rig": "Add rig equipment",
  "ShipDataView_nautical_add_device": "Add device",
  "ShipDataView_safety_add_device": "Add equipment",
  "ShipDataView_electric_add_device": "Add device",

  "ShipDataView_insurance": "Insurance",
  "ShipDataView_insurances": "Insurances",
  "ShipDataView_insurance_": "*Choose or enter* ",
  "ShipDataView_insurance_null": "*Choose or enter* ",
  "ShipDataView_insurance_undefined": "*Choose or enter* ",
  "ShipDataView_insurance_company": "Insurance company",
  "ShipDataView_insurance_number": "Insurance number",
  "ShipDataView_insurance_type": "Type of insurance",
  "ShipDataView_insurance_hull": "Hull",
  "ShipDataView_insurance_liability": "Liability",
  "ShipDataView_insurance_accident": "Accident",

  "ShipDataView_engines": "Engines",
  "ShipDataView_engine": "Engine",
  "ShipDataView_engine#": "No.",
  "ShipDataView_engine_nmea_number": "NMEA",
  "ShipDataView_engine_short_name": "Name (max. 10 char.)",
  "ShipDataView_engine_": "*Choose or enter* ",
  "ShipDataView_engine_undefined": "*Choose or enter* ",
  "ShipDataView_engine_null": "*Choose or enter* ",

  "ShipDataView_engine_outboard": "Outboard",
  "ShipDataView_engine_saildrive": "Saildrive",
  "ShipDataView_engine_shaftdrive": "Shaft drive",
  "ShipDataView_engine_z_drive": "Z drive",
  "ShipDataView_engine_pod_drive": "Pod drive",
  "ShipDataView_engine_jet_drive": "Jet drive",

  "ShipDataView_generator_": "*Choose or enter* ",
  "ShipDataView_generator_undefined": "*Choose or enter* ",
  "ShipDataView_generator_null": "*Choose or enter* ",

  "ShipDataView_generator": "Generator",
  "ShipDataView_generators": "Generators",
  "ShipDataView_generator_power_generator": "Power generator",
  "ShipDataView_generator_warm_water": "Warm water",
  "ShipDataView_generator_watermaker": "Watermaker",
  "ShipDataView_generator_heating": "Heating",
  "ShipDataView_generator_air_conditioning": "Air conditioning",

  "ShipDataView_fuel_": "*Choose or enter* ",
  "ShipDataView_fuel_null": "*Choose or enter* ",
  "ShipDataView_fuel_undefined": "*Choose or enter* ",
  "ShipDataView_fuel_type": "Fuel",
  "ShipDataView_fuel_diesel": "Diesel",
  "ShipDataView_fuel_petrol": "Petrol",
  "ShipDataView_fuel_gas": "Gas",
  "ShipDataView_fuel_electricity": "Electricity",

  "ShipDataView_drive_type_engine_null": "*Choose or enter* ",
  "ShipDataView_number": "Number",
  "ShipDataView_manufacturer": "Manufacturer",
  "ShipDataView_model": "Model",
  "ShipDataView_serial_number": "Serial number",
  "ShipDataView_power": "Power",
  "ShipDataView_drive_type": "Drive type",
  "ShipDataView_propeller_type": "Propeller type",

  "ShipDataView_steering_null": "*Choose or enter* ",
  "ShipDataView_steering_systems": "Steering systems",
  "ShipDataView_steering_system_main": "Main steering system",
  "ShipDataView_steering_": "*Choose or enter* ",
  "ShipDataView_steering_type": "Steering type",
  "ShipDataView_rudder_no": "No. of rudders",
  "ShipDataView_rudder_shape": "Shape",
  "ShipDataView_rudder_drive": "Rudder drive",
  "ShipDataView_steering_bow_thruster": "Bow thruster",
  "ShipDataView_steering_stern_thruster": "Stern thruster",
  "ShipDataView_steering_self_steering": "Self steering",
  "ShipDataView_steering_windvane": "Windvane",
  "ShipDataView_steering_trimtab": "Trim-tab",
  "ShipDataView_steering_autopilot": "Autopilot",

  "ShipDataView_tanks": "Tanks",
  "ShipDataView_tanks_unit": "tanks: ∑ ",
  "ShipDataView_tank": "Type of tank",
  "ShipDataView_tank_": "*Choose or enter* ",
  "ShipDataView_tank_undefined": "*Choose or enter* ",
  "ShipDataView_tank_null": "*Choose or enter* ",

  "ShipDataView_tank_fuel": "Fuel",
  "ShipDataView_tank_water": "Fresh water",
  "ShipDataView_tank_gray": "Gray water",
  "ShipDataView_tank_waste": "Waste water",
  "ShipDataView_tank_gas": "Gas",
  "ShipDataView_tank_fuel_daytank": "Fuel day tank",

  "ShipDataView_tank_size": "Size",
  "ShipDataView_tank_comment": "Comment",

  "ShipDataView_no": "number",
  "ShipDataView_tank_fuel_no": "Fuel: no. | ∑ size",
  "ShipDataView_tank_water_no": "Fresh water: no. | ∑ size",
  "ShipDataView_tank_gray_no": "Gray water: no. | ∑ size",
  "ShipDataView_tank_waste_no": "Waste water:no. | ∑ size",
  "ShipDataView_tank_gas_no": "Gas: no. | ∑ size",

  "ShipDataView_anchors": "Anchors",
  "ShipDataView_anchor_type": "Anchor type",
  "ShipDataView_anchor_": "*Choose or enter* ",
  "ShipDataView_anchor_null": "*Choose or enter* ",

  "ShipDataView_anchor_weight": "Weight",
  "ShipDataView_anchor_location": "Place of installation",

  "ShipDataView_bow": "bow",
  "ShipDataView_stern": "stern",
  "ShipDataView_variable": "variable",

  "ShipDataView_anchor_chain": "Length and type of chain",
  "ShipDataView_anchor_chain_lead": "Chain lead",
  "ShipDataView_anchor_windlass": "Anchor windlass",
  "ShipDataView_anchor_windless_drive": "Drive",
  "ShipDataView_anchor_windless_manfacturer": "Manufacturer",

  "ShipDataView_anchor_spade": "Spade anchor",
  "ShipDataView_anchor_fishermans": "Fisherman's anchor",
  "ShipDataView_anchor_plough": "CQR/plough anchor",
  "ShipDataView_anchor_danforth": "Danforth",
  "ShipDataView_anchor_rollerbar": "Roller bar anchor",

  "ShipDataView_manual": "manual",
  "ShipDataView_electric": "electric",

  "ShipDataView_watermaker": "Watermaker",
  "ShipDataView_batteries": "Batteries",
  "ShipDataView_batterie": "Batterie",
  "ShipDataView_capacity": "Capacity",
  "ShipDataView_electrics": "Electrics",
  "ShipDataView_date_purchase": "Date of purchase",
  "ShipDataView_charger": "Charger",
  "ShipDataView_inverter": "Inverter",
  "ShipDataView_hot_water_boiler": "Hot water boiler",
  "ShipDataView_size": "Size",
  "ShipDataView_size_height": "Size/height",

  "ShipDataView_place_installation": "Place of installation",
  "ShipDataView_date_installation": "Date of installation",

  "ShipDataView_devices": "Devices",
  "ShipDataView_device": "Device",

  "ShipDataView_sails": "Sails",
  "ShipDataView_sail": "Sail",
  "ShipDataView_sail_": "*Choose or enter* ",
  "ShipDataView_sail_null": "*Choose or enter* ",

  "ShipDataView_sail_size": "Size",
  "ShipDataView_sail_type": "Set on",
  "ShipDataView_sail_reefs_no": "No. of reefs",

  "ShipDataView_sail_mast": "Mast",
  "ShipDataView_sail_forestay": "Forestay",
  "ShipDataView_sail_mizzen": "Mizzen",
  "ShipDataView_sail_mainsail": "Mainsail",
  "ShipDataView_sail_spinnaker": "Spinnaker",
  "ShipDataView_sail_genoa": "Genoa",
  "ShipDataView_sail_jib": "Jib",
  "ShipDataView_sail_working_jib": "Working jib",
  "ShipDataView_sail_strom_jib": "Storm jib",
  "ShipDataView_sail_mizzen_staysail": "Mizzen staysail",
  "ShipDataView_sail_code0": "Code 0",
  "ShipDataView_sail_gennaker": "Gennaker",
  "ShipDataView_sail_try": "Try sail",
  "ShipDataView_sail_storm_jib": "Storm jib",
  "ShipDataView_sail_parasailor": "Parasailor",
  "ShipDataView_sail_0": "None",
  "ShipDataView_sail_1": "1",
  "ShipDataView_sail_2": "2",
  "ShipDataView_sail_3": "3",
  "ShipDataView_sail_reef_1": "Reef 1",
  "ShipDataView_sail_reef_2": "Reef 2",
  "ShipDataView_sail_reef_3": "Reef 3",
  "ShipDataView_sail_reef": "{sail} - {reef}",

  "ShipDataView_device_": "*Choose or enter* ",
  "ShipDataView_device_undefined": "*Choose or enter* ",
  "ShipDataView_device_nautical_": "*Choose or enter* ",
  "ShipDataView_device_electric_": "*Choose or enter* ",
  "ShipDataView_device_safety_": "*Choose or enter* ",
  "ShipDataView_device_nautical_null": "*Choose or enter* ",
  "ShipDataView_device_electric_null": "*Choose or enter* ",
  "ShipDataView_device_safety_null": "*Choose or enter* ",

  "ShipDataView_nautical_equipment": "Nautical equipment",
  "ShipDataView_safety_equipment": "Safety equipment",
  "ShipDataView_electric_equipment": "Electric equipment",

  "ShipDataView_device_nautical_analogue_compass": "Analogue compass",
  "ShipDataView_device_nautical_gyro_compass": "Gyro compass",
  "ShipDataView_device_nautical_fluxgate_compass": "Fluxgate compass",
  "ShipDataView_device_nautical_satellite_compass": "Satellite compass",
  "ShipDataView_device_nautical_chart_plotter": "Chart plotter",
  "ShipDataView_device_nautical_gps": "GPS",
  "ShipDataView_device_nautical_ais": "AIS transponder",
  "ShipDataView_device_nautical_radio": "Radio",
  "ShipDataView_device_nautical_antenna": "Antenna",
  "ShipDataView_device_nautical_radar": "Radar",
  "ShipDataView_device_nautical_wind_gauge": "Wind gauge",
  "ShipDataView_device_nautical_autopilot": "Autopilot",
  "ShipDataView_device_nautical_display_instruments": "Display instruments",
  "ShipDataView_device_nautical_fuel_gauge": "Fuel gauge",
  "ShipDataView_device_nautical_battery_controller": "Battery controller",
  "ShipDataView_device_nautical_hour_meter": "Hour meter",
  "ShipDataView_device_nautical_tachometer": "Tachometer",
  "ShipDataView_device_nautical_logger": "Logger",
  "ShipDataView_device_nautical_sounder": "Sounder",
  "ShipDataView_device_nautical_air_temperature": "Air temperature",
  "ShipDataView_device_nautical_barometer": "Barometer",
  "ShipDataView_device_nautical_humidity": "Humidity",
  "ShipDataView_device_nautical_weather_receiver": "Weather receiver",
  "ShipDataView_device_nautical_nmea_gateway": "NMEA gateway",
  "ShipDataView_device_nautical_nmea_motor_adapter": "NMEA motor adapter",

  "ShipDataView_device_electric_battery": "Battery",
  "ShipDataView_device_electric_inverter": "Inverter",
  "ShipDataView_device_electric_charger": "Charger",
  "ShipDataView_device_electric_solar_panel": "Solar panel",
  "ShipDataView_device_electric_wind_generator": "Wind generator",
  "ShipDataView_device_electric_watermaker": "Watermaker",

  "ShipDataView_device_safety_fire_extinguisher": "Fire extinguisher",
  "ShipDataView_device_safety_liferaft": "Liferaft",
  "ShipDataView_device_safety_lifejacket": "Lifejacket",
  "ShipDataView_device_safety_lifebelt": "Lifebelt",
  "ShipDataView_device_safety_lifeline": "Lifeline",
  "ShipDataView_device_safety_spare_propeller": "Spare propeller",
  "ShipDataView_device_safety_emergency_tiller": "Emergency tiller",
  "ShipDataView_device_safety_bilge_pump_manual": "Manual bilge pump",
  "ShipDataView_device_safety_bilge_pump_electric": "Electric bilge pump",
  "ShipDataView_device_safety_shroud_cutter": "Shroud cutter",
  "ShipDataView_device_safety_radar_reflector": "Radar reflector",
  "ShipDataView_device_safety_first_aid": "First Aid",
  "ShipDataView_device_safety_fire_blanket": "Fire blanket",
  "ShipDataView_device_safety_dinghy": "Dinghy ",
  "ShipDataView_device_safety_dinghy_motor": "Motor for dinghy",
  "ShipDataView_device_safety_handheld_radio": "Handheld radio",
  "ShipDataView_device_safety_epirb": "Epirb",
  "ShipDataView_all_users": "All persons for crew etc.",

  "ShipEditView": "",
  "ShipEditView_name": "Name of the ship",
  "ShipEditView_name_min": "Name of the ship (min 3 characters)",
  "ShipEditView_title_edit": "Ship data for {ship}",
  "ShipEditView_title_new": "Create new Ship",
  "ShipEditView_type": "Vessel type",
  "ShipEditView_type_motor": "Motor vessel",
  "ShipEditView_type_sailing": "Sailing vessel",
  "ShipEditView_engines": "No. of Engines",
  "ShipEditView_generators": "No. of Generators",
  "ShipEditView_create": "Create Ship",
  "ShipEditView_cancel": "Cancel",
  "ShipEditView_choose": "Choose",
  "ShipEditView_print": "Print Ship data",

  "ShipSelectView": "",
  "ShipSelectView_companion": "C",
  "ShipSelectView_view_logbook": "View",
  "ShipSelectView_selecting": "Selecting...",
  "ShipSelectView_options": "Options",
  "ShipSelectView_nearby": "Found on your network",
  "ShipSelectView_nearby_hint": "This ship is being advertised on your current network.",
  "ShipSelectView_unavailable_no_permission": "You do not have permission to open this ship as the Primary LOGBOOK.",
  "ShipSelectView_unavailable_import_in_progress": "An import is still running for this ship.",

  "ShipSyncStatusView": "",
  "ShipSyncStatusView_close": "Close",
  "ShipSyncStatusView_retry": "Try again",
  "ShipSyncStatusView_title": "Synchronization with LOGBOOK Cloud",

  "ShipUserSelect": "",
  "ShipUserSelect_add_user": "Add Person",
  "ShipUserSelect_dialog_add_new_user": "Add new Person",
  "ShipUserSelect_dialog_add_user": "Add new Person",
  "ShipUserSelect_dialog_add_user_name": "Name",
  "ShipUserSelect_dialog_add_user_shortname": "Short name",
  "ShipUserSelect_dialog_cancel": "Cancel",
  "ShipUserSelect_loading": "Loading…",
  "ShipUserSelect_no_users": "No people available",
  "ShipUserSelect_select_additional_user": "+",
  "ShipUserSelect_select_user": "Select Person",

  "ShipView": "",

  "ShipView_add_cruise": "Voyage",
  "ShipView_add_ship": "Ship",
  "ShipView_empty_select": "Select a ship first.",

  "ShipView_import_trips_title": "Import older Passages from LogbookSuite",
  "ShipView_import_trips_choose": "Choose file",
  "ShipView_import_trips_cancel": "Cancel",

  "ShipView_menu_action_title": "New",
  "ShipView_menu_NMEA": "NMEA",
  "ShipView_menu_now": "Focus",
  "ShipView_menu_search": "Search",
  "ShipView_nmea_recording_disconnected": "NMEA disconnected",
  "ShipView_nmea_recording_error": "NMEA recording error:",
  "ShipView_nmea_recording_error_disconnected": "NMEA recording error: NMEA not connected",
  "ShipView_overlay_dismiss": "OK",
  "ShipView_overlay_missing_cruise": "Can not start recording without an active passage and voyage. Create a voyage first.",
  "ShipView_overlay_missing_trip": "Can not start recording without an active passage. Create a passage first.",
  "ShipView_ship_data": "Ship data",
  "ShipView_ship_settings": "Settings",
  "ShipView_sync_initialSyncInProgress": "Running initial sync",
  "ShipView_sync_settings": "Settings",
  "ShipView_sync_uninitialized": "Preparing to sync",

  "ShipView_resync_cancel": "Cancel",
  "ShipView_resync_confirm_cancel": "Back",
  "ShipView_resync_confirm_execute": "Confirm",
  "ShipView_resync_title": "Reset disconnected connection",
  "ShipView_resync_reset_local": "Use local data",
  "ShipView_resync_reset_cloud": "Use Cloud data",
  "ShipView_resync_last_sync": "This device last synchronised",
  "ShipView_resync_cloud_updated": "LOGBOOK Cloud last updated",
  "ShipView_resync_status_failed": "The LOGBOOK Cloud could not be reached, so the connection status is unknown. Check your internet connection and try again.",
  "ShipView_resync_permission_required": "Your cloud account no longer has Primary permission for this ship. Synchronisation and recovery require that permission. Ask the ship owner to restore it, then retry synchronisation. Keep this ship open to preserve unsynchronised local changes; releasing the cloud connection alone will not restore permission.",
  "ShipView_resync_claimed_here": "The LOGBOOK Cloud still recognises this device as the Primary. A reset cannot run while that connection is active. Retry synchronisation first. If a reset is still needed, close the ship in the LOGBOOK Cloud, then reopen this dialog and choose which data to keep. Keep the ship open in this app until recovery is complete to preserve unsynchronised local changes.",
  "ShipView_resync_reset_failed": "The connection could not be restored. Please try again.",
  "ShipView_resync_reset_claimed": "The cloud refused recovery. Your permission or the ship's connection may have changed. Go back to check the current status before trying again.",
  "ShipView_read_more": "Read more",

  "StatsView": "",
  "StatsView_days_run": "Day's run",
  "StatsView_distance_total": "Total distance",
  "StatsView_distance_under_engine": "Distance under Engine",
  "StatsView_distance_under_engine_name": "{name}",
  "StatsView_distance_under_sails": "Distance under sails",
  "StatsView_duration_under_engine": "Time under Engine",
  "StatsView_duration_under_engine_name": "{name}",
  "StatsView_duration_under_sails": "Time under sails",
  "StatsView_speed": "Average speed",
  "StatsView_time_total": "Time total",
  "StatsView_time_total_paused_cruising": "Time: Total | Paused | Cruising",
  "StatsView_update": "Recalculate",

  "TrackView": "",
  "TrackView_no_track": "No track available",

  "TripEditView": "",
  "TripEditView_cancel": "Cancel",
  "TripEditView_current_time": "Current time",
  "TripEditView_dialog_title": "Create Passage",
  "TripEditView_start": "Start Passage",
  "TripEditView_timezone": "Timezone",
  "TripEditView_title": "Name of the passage",

  "TripView": "",
  "TripView_tab_crew": "Crew",
  "TripView_tab_stats": "Statistics",
  "TripView_tab_track": "Track",
  "TripView_tab_trip": "Passage",
  "TripView_tab_weather": "Weather",
  "TripView_tab_print": "Print",
  "TripView_untitled_trip": "Untitled passage",
  "TripView_print_all": "Print all passages of this voyage",
  "TripView_print_trip": "Print this passage",

  "UserAdviceAlertView": "",
  "UserAdviceAlertView_alert_acknowledged": "Acknowledged",
  "UserAdviceAlertView_alert_alarm": "Alarm",
  "UserAdviceAlertView_alert_anchorDrift": "Anchor drift",
  "UserAdviceAlertView_alert_anchorDrift_short": "Drift",
  "UserAdviceAlertView_alert_default": "Unknown",
  "UserAdviceAlertView_alert_depth": "Depth",
  "UserAdviceAlertView_alert_depth_short": "Depth",
  "UserAdviceAlertView_alert_ignored": "Ignored",
  "UserAdviceAlertView_alert_lostPosition": "Lost position",
  "UserAdviceAlertView_alert_lostPosition_short": "Position",
  "UserAdviceAlertView_alert_message": "Message",
  "UserAdviceAlertView_alert_message_short": "Message",
  "UserAdviceAlertView_alert_ok": "OK",
  "UserAdviceAlertView_alert_pressure": "Pressure",
  "UserAdviceAlertView_alert_pressure_short": "Pressure",
  "UserAdviceAlertView_alert_resolved": "Resolved",
  "UserAdviceAlertView_alert_test": "Test",
  "UserAdviceAlertView_alert_test_short": "Test",
  "UserAdviceAlertView_alert_warning": "Warning",
  "UserAdviceAlertView_alert_wind": "Wind",
  "UserAdviceAlertView_alert_wind_short": "Wind",
  "UserAdviceAlertView_alert_lights": "Visual signals",
  "UserAdviceAlertView_alert_lights_short": "Lights",
  "UserAdviceAlertView_alert_manOverboard": "Man overboard",
  "UserAdviceAlertView_alert_manOverboard_short": "MOB",
  "UserAdviceAlertView_state_snoozed": "Snoozed",
  "UserAdviceAlertView_state_acknowledged": "Acknowledged",
  "UserAdviceAlertView_state_audible": "Sounding",
  "UserAdviceAlertView_close": "Close",
  "UserAdviceAlertView_record": "I set {lighting}",
  "UserAdviceAlertView_cancel": "Cancel",
  "UserAdviceAlertView_settings": "Settings",
  "UserAdviceAlertView_submit": "Set status: {state}",
  "UserAdviceAlertView_submit_none": "Choose an action",
  "UserAdviceAlertView_state_snooze": "Snoozed",
  "UserAdviceAlertView_state_acknowledge": "Acknowledged",
  "UserAdviceAlertView_state_clear": "Cleared",
  "UserAdviceAlertView_state_record": "Recorded",
  "UserAdviceAlertView_explain_snooze": "Silences the alert for a few minutes. It stays open and returns if the situation persists.",
  "UserAdviceAlertView_explain_acknowledge": "Marks the alert as seen and stops it sounding. It stays open until the situation resolves.",
  "UserAdviceAlertView_explain_clear": "Closes the alert. Use this once the situation has actually been dealt with.",
  "UserAdviceAlertView_explain_record": "Records the recommended lighting in the log. The reminder closes by itself once the lighting matches.",
  "UserAdviceAlertView_clear_denied": "Only the skipper or the crew on watch can clear this alert.",
  "UserAdviceAlertView_clear_confirm_message": "This closes the alert for everyone on board, whether or not the situation still holds. Only clear it once it has actually been dealt with.",
  "UserAdviceAlertView_clear_confirm": "Clear the alert",
  "UserAdviceAlertView_clear_confirm_cancel": "Back",
  "UserAdviceAlertView_escalate": "Escalate to skipper",
  "UserAdviceAlertView_state_escalate": "Escalated to skipper",
  "UserAdviceAlertView_explain_escalate": "Alerts the skipper now instead of waiting for the alarm to escalate by itself. This also undoes an acknowledgement or snooze, so the alarm reaches them.",
  "UserAdviceAlertView_skip": "Skip",
  "UserAdviceAlertView_acknowledge": "Acknowledge",
  "UserAdviceAlertView_clear": "Clear",
  "UserAdviceAlertView_snooze": "Snooze",
  "UserAdviceAlertView_title": "Alert {name} - {level}",
  "UserAdviceAlertView_error": "The action could not be completed. Please try again.",
  "UserAdviceAlertView_read_more": "Read more",

  "UserAdviceAnchorMonitorView": "",
  "UserAdviceAnchorMonitorView_cancel": "Cancel",
  "UserAdviceAnchorMonitorView_disable": "Disable",
  "UserAdviceAnchorMonitorView_enable": "Enable alarm",
  "UserAdviceAnchorMonitorView_title_inactive": "Anchor Alarm Off",
  "UserAdviceAnchorMonitorView_title_active": "Anchor Alarm On",
  "UserAdviceAnchorMonitorView_title_short": "Anchor Alarm",
  "UserAdviceAnchorMonitorView_method": "Method",
  "UserAdviceAnchorMonitorView_method_fixedRadius": "Fixed radius",
  "UserAdviceAnchorMonitorView_method_rodeScope": "Rode / scope",
  "UserAdviceAnchorMonitorView_method_sector": "Swing sector",
  "UserAdviceAnchorMonitorView_warning": "Warning",
  "UserAdviceAnchorMonitorView_alarm": "Alarm",
  "UserAdviceAnchorMonitorView_rode": "Rode",
  "UserAdviceAnchorMonitorView_depth": "Depth",
  "UserAdviceAnchorMonitorView_boatLength": "Boat length",
  "UserAdviceAnchorMonitorView_bearingFrom": "From bearing",
  "UserAdviceAnchorMonitorView_bearingTo": "To bearing",
  "UserAdviceAnchorMonitorView_recenter": "Recenter",
  "UserAdviceAnchorMonitorView_save": "Save",
  "UserAdviceAnchorMonitorView_snooze": "Snooze",
  "UserAdviceAnchorMonitorView_acknowledge": "Acknowledge",
  "UserAdviceAnchorMonitorView_clear": "Clear",
  "UserAdviceAnchorMonitorView_keepAlive": "Keep alerting in background",
  "UserAdviceAnchorMonitorView_depthWarning": "Depth warning",
  "UserAdviceAnchorMonitorView_depthAlarm": "Depth alarm",
  "UserAdviceAnchorMonitorView_error": "The anchor watch could not be updated. Please try again.",
  "UserAdviceAnchorMonitorView_error_noPosition": "The anchor alarm needs the current position to set its centre, and there is no position right now. Connect an NMEA GPS source (or enable the device GPS) and try again.",
  "UserAdviceAnchorMonitorView_error_gpsPrecision": "The current position is not precise enough for the anchor alarm. It needs a high-precision GPS source; the device GPS alone is too coarse to measure the swing circle.",
  "UserAdviceAnchorMonitorView_error_noDay": "The anchor alarm can only be started once the day has begun and a first position has been recorded. Your settings have been saved; start the anchor alarm again once the logbook is recording.",
  "UserAdviceAnchorMonitorView_read_more": "Read more",

  "UserAdviceEngineMissingView": "",
  "UserAdviceEngineMissingView_title_short": "Engine?",
  "UserAdviceEngineMissingView_title_castOff": "Engine entry missing?",
  "UserAdviceEngineMissingView_title_anchorUp": "Engine entry missing?",
  "UserAdviceEngineMissingView_title_motorVessel": "Engine entry missing?",
  "UserAdviceEngineMissingView_text_castOff": "You cast off with no engine recorded. Was the engine running?",
  "UserAdviceEngineMissingView_text_anchorUp": "You got under way with no engine recorded. Was the engine running?",
  "UserAdviceEngineMissingView_text_motorVessel": "You are under way with no engine recorded. Was the engine running?",
  "UserAdviceEngineMissingView_all_engines": "All engines",
  "UserAdviceEngineMissingView_since_trigger": "Since {time}",
  "UserAdviceEngineMissingView_since_now": "From now",
  "UserAdviceEngineMissingView_started": "Engine was running",
  "UserAdviceEngineMissingView_sailing": "No, we're sailing",
  "UserAdviceEngineMissingView_sailing_noSails": "No engine running",
  "UserAdviceEngineMissingView_cancel": "Cancel",
  "UserAdviceDepthWatchView": "",
  "UserAdviceDepthWatchView_cancel": "Cancel",
  "UserAdviceDepthWatchView_disable": "Disable",
  "UserAdviceDepthWatchView_enable": "Enable alarm",
  "UserAdviceDepthWatchView_title_inactive": "Depth Alarm Off",
  "UserAdviceDepthWatchView_title_active": "Depth Alarm On",
  "UserAdviceDepthWatchView_title_short": "Depth Alarm",
  "UserAdviceDepthWatchView_snooze": "Snooze",
  "UserAdviceDepthWatchView_acknowledge": "Acknowledge",
  "UserAdviceDepthWatchView_clear": "Clear",
  "UserAdviceDepthWatchView_text": "Changing these values updates your ship's depth alert settings.",
  "UserAdviceDepthWatchView_save": "Save",
  "UserAdviceDepthWatchView_save_error": "The depth alert settings could not be saved. Please try again.",
  "UserAdviceDepthWatchView_error": "The depth watch could not be updated. Please try again.",

  "UserAdviceLightsReminderView": "",
  "UserAdviceLightsReminderView_title": "Visual signals",
  "UserAdviceLightsReminderView_title_active": "Visual signals Reminder On",
  "UserAdviceLightsReminderView_title_inactive": "Visual signals Reminder Off",

  "UserAdviceManualShipStatusView": "",
  "UserAdviceManualShipStatusView_title_active": "Manual status until {time}",
  "UserAdviceManualShipStatusView_title_short": "Manual status",
  "UserAdviceManualShipStatusView_text": "The automatic status changes are switched off. Set the ship status yourself in the log menu — no entry is made automatically while this is on.",
  "UserAdviceManualShipStatusView_remaining": "Ends at {time}, in about {minutes} minutes — or at the day change, whichever comes first.",
  "UserAdviceManualShipStatusView_extend": "Extend",
  "UserAdviceManualShipStatusView_cancel": "End now",
  "UserAdviceManualShipStatusView_close": "Close",
  "UserAdviceManualShipStatusView_error": "The manual status mode could not be updated. Please try again.",

  "UserAdviceStopView": "",
  "UserAdviceStopView_cancel": "Cancel",
  "UserAdviceStopView_text": "Document the stop. End of day pauses automatic recording until the ship moves again; Stopover keeps recording active.",
  "UserAdviceStopView_text_fixed_status": "Add End of day or Stopover without changing the current ship status. End of day pauses automatic recording until the ship moves again; Stopover keeps recording active.",
  "UserAdviceStopView_end_location": "Location",
  "UserAdviceStopView_end_of_day": "End of day",
  "UserAdviceStopView_manual_engine_entries": "Also turned off engine(s)?",
  "UserAdviceStopView_manual_engine_entries_text": "Enabling this option will also create a final entry for engine operation",
  "UserAdviceStopView_final_entry": "Create final entry",
  "UserAdviceStopView_save": "Save",
  "UserAdviceStopView_status_anchor": "Anchorage",
  "UserAdviceStopView_status_buoy": "Buoy",
  "UserAdviceStopView_status_port": "Harbor",
  "UserAdviceStopView_status_drifting": "Drifting",
  "UserAdviceStopView_stopover": "Stopover",
  "UserAdviceStopView_status_lock": "Lock",
  "UserAdviceStopView_status_bunkering": "Fuel station",
  "UserAdviceStopView_status_bridge": "Bridge",
  "UserAdviceStopView_status_waiting": "Waiting",
  "UserAdviceStopView_stop_engines": "Create entry for stopped engine(s)",
  "UserAdviceStopView_stop_type": "Stop type",
  "UserAdviceStopView_title": "Stopped",
  "UserAdviceStopView_title_duration": "Stopped for {duration}",
  "UserAdviceStopView_title_short": "Stopped",
  "UserAdviceRow_collapse": "Show less",
  "UserAdviceRow_expand": "Show all advices",

  "UserSettingsView": "",
  "UserSettingsView_lang_en": "English",
  "UserSettingsView_lang_de": "Deutsch",
  "UserSettingsView_lang_fr": "Français",
  "UserSettingsView_theme_dark": "Dark",
  "UserSettingsView_theme_light": "Classic",
  "UserSettingsView_theme_night": "Night",
  "UserSettingsView_theme_cloud": "Cloud",
  "UserSettingsView_language": "Language",
  "UserSettingsView_theme": "Theme",

  "UserSwitchView": "",
  "UserSwitchView_title": "Switch User",
  "UserSwitchView_empty": "No other crew members are recorded for today.",

  "Mailer_trial_started_subject": "Your LOGBOOK Trial has started",
  "Mailer_trial_2daysleft_subject": "Your LOGBOOK Trial is ending soon",
  "Mailer_trial_expired_subject": "Your LOGBOOK Trial phase has expired",
  "Mailer_subscription_expired_subject": "Your LOGBOOK subscription has expired",

  "LogButton": "",
  "LogButton_status": "Status",
  "LogButton_engines": "Engines",
  "LogButton_generators": "Generators",
  "LogButton_lighting": "Lighting",
  "LogButton_lighting_none": "No lights",
  "LogButton_lighting_triColorLights": "Tri-colour light",
  "LogButton_lighting_anchorBall": "Anchor ball",
  "LogButton_lighting_anchorLight": "Anchor light",
  "LogButton_lighting_sailingRunningLights": "Sailing lights",
  "LogButton_lighting_motoringRunningLights": "Motoring lights",
  "LogButton_lighting_navigationLights": "Navigation lights",
  "LogButton_lighting_motoringCone": "Motoring cone",
  "LogButton_sails": "Sails",
  "LogButton_sails_confirm": "Save sails",
  "LogButton_sail_group_main": "Main",
  "LogButton_sail_group_foresail": "Foresail",
  "LogButton_sail_group_spinnaker": "Spinnaker",
  "LogButton_sail_group_mizzen": "Mizzen",
  "LogButton_send_alert": "Send alert",
  "LogButton_man_overboard": "Man overboard",
  "LogButton_man_overboard_confirm_title": "Man overboard",
  "LogButton_man_overboard_confirm_message": "This will immediately alert the entire crew that someone has gone overboard. Only confirm if this is real.",
  "LogButton_man_overboard_confirm": "Trigger alert",
  "LogButton_man_overboard_cancel": "Cancel",
  "LogButton_man_overboard_error": "Could not trigger the man-overboard alert.",
  "LogButton_manual_status": "Manual status",
  "LogButton_manual_status_active": "Manual status on — switch off",
  "SendAlertDialog": "",
  "SendAlertDialog_title": "Send alert",
  "SendAlertDialog_users": "Crew members",
  "SendAlertDialog_add_user": "Add crew member",
  "SendAlertDialog_groups": "Watch groups",
  "SendAlertDialog_add_group": "Add watch group",
  "SendAlertDialog_message": "Message",
  "SendAlertDialog_severity": "Severity",
  "SendAlertDialog_severity_warning": "Warning",
  "SendAlertDialog_severity_alarm": "Alarm",
  "SendAlertDialog_loudness": "Loudness",
  "SendAlertDialog_loudness_audible": "Audible alarm",
  "SendAlertDialog_loudness_notificationOnly": "Notification only",
  "SendAlertDialog_error": "The alert could not be sent. Please try again.",
  "SendAlertDialog_cancel": "Cancel",
  "SendAlertDialog_send": "Send",
  "CatalogUserAdviceButton": "",
  "CatalogUserAdviceButton_notice": "Anchor watch active",
  "CatalogUserAdviceButton_warning": "Wind picking up",
  "CatalogUserAdviceButton_alarm": "Man overboard!",
  "CatalogUserAdviceButton_short": "MOB",
  "CatalogUserAdviceButton_record": "Record anchor light",
  "CatalogUserAdviceButton_primary-action": "Visual signals",
  "CatalogUserAdviceButton_primary-action-denied": "Visual signals",
  "CatalogUserAdviceRow": "",
  "CatalogUserAdviceRow_manOverboard": "Man overboard",
  "CatalogUserAdviceRow_manOverboard_short": "MOB",
  "CatalogUserAdviceRow_anchorDrift": "Anchor drift",
  "CatalogUserAdviceRow_anchorDrift_short": "Drift",
  "CatalogUserAdviceRow_depth": "Depth Alarm On",
  "CatalogUserAdviceRow_depth_short": "Depth Alarm",
  "CatalogUserAdviceRow_lostPosition": "Lost position",
  "CatalogUserAdviceRow_lostPosition_short": "Position",
  "CatalogUserAdviceRow_wind": "Wind warning",
  "CatalogUserAdviceRow_wind_short": "Wind",
  "CatalogUserAdviceRow_stop": "Stopped for 0:12:04",
  "CatalogUserAdviceRow_stop_short": "Stopped",
  "": ""
}
